

// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';

// const LeaveManagement = () => {
//     const navigate = useNavigate();
//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
//     const [pendingWFH, setPendingWFH] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     useEffect(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email
//                 .toLowerCase()
//                 .includes("genesistech.co.in");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, []);

//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;

//     const teams = useMemo(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email
//                 .toLowerCase()
//                 .includes("genesistech.co.in");

//         return isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//     }, [dashboardDepartments]);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return leaves.filter(l => l.Status === '0' || l.Status === null).length;
//     }, [leaves]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             // const storedUser = localStorage.getItem('user');
//             const storedUser = localStorage.getItem('userData');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
//                 credentials: "include"
//             });

//             const data = await res.json();



//             if (data.success) {
//                 setLeaves(data.leaves);
//                 setAllEmployees(data.employees);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 await fetchData(); // Refresh list
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {
//         const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
//         const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
//         setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {
//         const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
//         if (!targetId) {
//             alert("Error: No leave record selected.");
//             return;
//         }
//         const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
//         setProcessing(true);
//         try {
//             let authUser = {};
//             try {
//                 authUser = JSON.parse(localStorage.getItem('user')) || 
//                            JSON.parse(localStorage.getItem('userData')) || 
//                            JSON.parse(localStorage.getItem('employee')) || 
//                            JSON.parse(localStorage.getItem('auth')) || {};
//             } catch (e) {}

//             const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
//             const approverName = authUser.FirstName 
//                 ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim() 
//                 : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

//             const res = await fetch("/gt-api/update_leave_status.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: targetId,
//                     status: remarkModal.status,
//                     remark: finalRemark,
//                     approved_by_id: approverId,
//                     approved_by_name: approverName
//                 }),
//             });
//             const result = await res.json();
//             if (result.success) {
//                 alert("Leave request successfully " + (remarkModal.status === 1 ? "APPROVED" : "REJECTED") + "!");
//                 setLeaves(prevLeaves => prevLeaves.map(l => {
//                     const lId = l.id || l.leave_id || l.lid;
//                     if (String(lId) === String(targetId)) {
//                         return { ...l, Status: String(remarkModal.status), status: String(remarkModal.status), AdminRemark: finalRemark };
//                     }
//                     return l;
//                 }));
//                 await fetchData();
//                 setRemarkModal({ show: false, id: null, status: null, actionType: "" });
//                 setShowDetailModal(false);
//             } else {
//                 alert("Update failed: " + (result.message || "Server error"));
//             }
//         } catch (e) {
//             alert("Update failed: " + e.message);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const isInProbation = (joiningDate) => {
//         if (!joiningDate) return false;

//         const join = new Date(joiningDate);
//         const probationEnd = new Date(join);
//         probationEnd.setMonth(probationEnd.getMonth() + 6);

//         const today = new Date();

//         return today <= probationEnd;
//     };



//     useEffect(() => {

//         const fetchWFHCount = async () => {
//             try {

//                 const res = await fetch("/gt-api/get_all_wfh_requests.php", {
//                     credentials: "include"
//                 });

//                 const data = await res.json();

//                 if (data.success) {

//                     const pending = data.requests.filter(r => r.status === "Pending").length;

//                     setPendingWFH(pending);

//                 }

//             } catch (err) {

//                 console.error("WFH count fetch error", err);

//             }
//         };

//         fetchWFHCount();

//         const interval = setInterval(fetchWFHCount, 5000);

//         return () => clearInterval(interval);

//     }, []);



//     const leaveBalances = useMemo(() => {
//         const balances = {};
//         const now = new Date();

//         const currentFYStart = now.getMonth() >= 3
//             ? new Date(now.getFullYear(), 3, 1)
//             : new Date(now.getFullYear() - 1, 3, 1);

//         const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

//         // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
//         allEmployees.forEach(emp => {

//             if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

//             const joinDate = new Date(emp.JoiningDate);

//             let sickMonths = 12;
//             if (joinDate > currentFYStart) {
//                 sickMonths =
//                     3 - joinDate.getMonth() +
//                     12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
//             }

//             balances[emp.EmailId] = {
//                 email: emp.EmailId,
//                 name: emp.full_name,
//                 dept: emp.Department,
//                 sick: 0,
//                 sickQuota: sickMonths,
//                 earned: 0,
//                 maxEarned: Number(emp.Earnedcount) || 0
//             };
//         });

//         // ✅ STEP 2: APPLY LEAVES
//         leaves.forEach(l => {

//             const empKey = l.EmailId;
//             if (!balances[empKey]) return;

//             if (l.Status === '1') {

//                 const days = parseFloat(l.total) || 0;
//                 const type = l.leavetype?.toLowerCase() || "";
//                 const medStatus = String(l.medical_doc_status);
//                 const leaveDate = new Date(l.fromdate);

//                 // Sick leave (FY)
//                 if (
//                     leaveDate >= currentFYStart &&
//                     leaveDate <= currentFYEnd &&
//                     type.includes('sick') &&
//                     medStatus !== '2'
//                 ) {
//                     balances[empKey].sick += days;
//                 }

//                 // Earned leave
//                 if (
//                     (type.includes('earned') && medStatus !== '1') ||
//                     (type.includes('sick') && medStatus === '2')
//                 ) {
//                     balances[empKey].earned += days;
//                 }
//             }
//         });

//         return Object.values(balances).filter(emp =>
//             !summarySearch ||
//             emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
//         );

//     }, [leaves, allEmployees, summarySearch, summaryDepartment]);

//     const chartData = useMemo(() => {
//         const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

//         return teamsToDisplay.map(team => {
//             const teamFilteredLeaves = leaves.filter(l => {
//                 const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

//                 return l.Department === team && matchesMonth && matchesYear;
//             });

//             return {
//                 name: team,

//                 // ✅ SUM of leave units instead of count
//                 Approved: teamFilteredLeaves
//                     .filter(l => l.Status === '1')
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: teamFilteredLeaves
//                     .filter(l => (l.Status === '0' || l.Status === null))
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });
//     }, [leaves, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === '1') return 'Approved';
//         if (status === '2') return 'Rejected';
//         return 'Pending';
//     };

//     const filteredTableData = leaves.filter(l => {
//         const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//         const matchesDept = filters.department === 'All' || l.Department === filters.department;
//         const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//         const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//         const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
//             (l.empid && l.empid.toString().includes(searchTerm));
//         return matchesDept && matchesMonth && matchesYear && matchesSearch;
//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body detail-grid" style={{
//                             padding: '20px',
//                             overflowY: 'auto',
//                             flex: 1,
//                             scrollbarWidth: 'thin',
//                             scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
//                         }}>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>LEAVE TYPE:</strong> {
//                                     (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
//                                         ? 'Sick Leave (Medical Approved)'
//                                         : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
//                                             ? 'Earned Leave (Converted)'
//                                             : selectedLeave.leavetype
//                                 }
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
//                             </p>

//                             <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
//                                 <strong>REASON:</strong>
//                                 <div style={{
//                                     marginTop: '8px',
//                                     color: '#ccc',
//                                     lineHeight: '1.5',

//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'pre-wrap',
//                                     overflowWrap: 'break-word'
//                                 }}>
//                                     {selectedLeave.description || 'N/A'}
//                                 </div>
//                             </div>

//                             {(selectedLeave.proof || selectedLeave.medical_doc) && (
//                                 <div className="medical-review-panel" style={{
//                                     marginTop: '20px',
//                                     padding: '15px',
//                                     border: '1px solid #00ff9d',
//                                     borderRadius: '8px',
//                                     background: 'rgba(0, 255, 157, 0.05)',
//                                     marginBottom: '20px'
//                                 }}>
//                                     <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
//                                         DOCUMENTATION_REVIEW
//                                     </h4>

//                                     <img
//                                         src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
//                                         alt="Proof"
//                                         style={{
//                                             width: '100%',
//                                             maxHeight: '300px',
//                                             objectFit: 'contain',
//                                             marginBottom: '15px',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer',
//                                             border: '1px solid #333'
//                                         }}
//                                         onClick={() =>
//                                             window.open(
//                                                 `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
//                                                 '_blank'
//                                             )
//                                         }
//                                     />

//                                     {/* Only show status — no approve/reject buttons */}
//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '10px',
//                                         border: '1px solid #333',
//                                         borderRadius: '4px',
//                                         background: 'rgba(0,0,0,0.3)'
//                                     }}>
//                                         <span style={{
//                                             fontSize: '11px',
//                                             fontWeight: '800',
//                                             color:
//                                                 String(selectedLeave.medical_doc_status) === '1'
//                                                     ? '#00ff9d'
//                                                     : String(selectedLeave.medical_doc_status) === '2'
//                                                         ? '#ff4d4d'
//                                                         : '#ccc'
//                                         }}>
//                                             {String(selectedLeave.medical_doc_status) === '1'
//                                                 ? 'VERIFIED AS SICK LEAVE'
//                                                 : String(selectedLeave.medical_doc_status) === '2'
//                                                     ? 'REJECTED (REMAINS EARNED)'
//                                                     : 'PENDING REVIEW'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}



//                         </div>


//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
//                                 <div className="modal-footer-actions">
//                                     <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
//                                     <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                             <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
//                             <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
//                                 {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = leaves.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
//                         style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
//                     >

//                         {pendingWFH > 0 && (
//                             <span
//                                 style={{
//                                     position: "absolute",
//                                     top: "8px",
//                                     right: "10px",
//                                     background: "#ff4d4d",
//                                     color: "#fff",
//                                     fontSize: "12px",
//                                     fontWeight: "700",
//                                     padding: "3px 7px",
//                                     borderRadius: "12px",
//                                     lineHeight: "1",
//                                     marginTop: "27px",
//                                 }}
//                             >
//                                 {pendingWFH}
//                             </span>
//                         )}

//                         <h4 className="cyan-text">WFH_REQUESTS</h4>

//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>
//                                 {/* VIEW_WFH_REQUESTS */}
//                             </span>
//                         </div>

//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
//                         <h4 className="cyan-text">
//                             {"MEDICAL_REPORTS"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">

//                         </div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/leave-report')}
//                         style={{
//                             cursor: 'pointer',
//                             borderLeft: '4px solid #8b5cf6'
//                         }}
//                     >
//                         <h4 className="cyan-text">
//                             {"GENERATE_REPORT"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">
//                         </div>
//                     </div>
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>




//                 <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>

//                         <tr>

//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 EMPLOYEE
//                             </th>
//                             <th style={{ width: '170px', textAlign: 'left', padding: '12px' }}>
//                                 DEPT
//                             </th>
//                             <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
//                                 TYPE
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 FROM
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 TO
//                             </th>

//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 UNIT
//                             </th>
//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>
//                                 STATUS
//                             </th>
//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 REVIEW
//                             </th>

//                             <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                                 LEAVE CONVERT
//                             </th>



//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 ACTION
//                             </th>
//                         </tr>

//                     </thead>
//                     <tbody>
//                         {currentEntries.map((l, i) => {
//                             const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
//                             const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

//                             return (
//                                 <tr key={i} className="row-hover">

//                                     <td
//                                         className="emp-name-cell"
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '4px'
//                                             }}
//                                         >
//                                             {l.FirstName} {l.LastName}

//                                             {isInProbation(l.JoiningDate) && (
//                                                 <span
//                                                     className="probation-badge"
//                                                     style={{
//                                                         width: 'fit-content',
//                                                         padding: '2px 8px',
//                                                         fontSize: '11px'
//                                                     }}
//                                                 >
//                                                     PROBATION
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.Department}
//                                     </td>






//                                     <td
//                                         style={{
//                                             position: 'relative',
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <div style={{
//                                                 color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 {/* The primary name toggle */}
//                                                 {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
//                                                     String(l.medical_doc_status) === '2' ? 'Earned Leave' :
//                                                         l.leavetype}

//                                                 {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
//                                                 {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
//                                                     <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
//                                                         (MEDICAL APPROVED)
//                                                     </small>
//                                                 )}
//                                             </div>


//                                         </div>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.fromdate}
//                                     </td>
//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.todate}
//                                     </td>

//                                     <td
//                                         style={{
//                                             fontWeight: 'bold',
//                                             color: '#00fff2',
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {parseFloat(l.total)}
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                             {getStatusLabel(l.Status)}
//                                         </span>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '8px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
//                                             <button
//                                                 className="info-btn-circle"
//                                                 onClick={() => {
//                                                     setSelectedLeave(l);
//                                                     setShowDetailModal(true);
//                                                 }}
//                                             >
//                                                 <span className="info-icon">i</span>
//                                             </button>
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <button
//                                             className="convert-type-btn"
//                                             title="Toggle Leave Type"
//                                             onClick={() => {
//                                                 const isCurrentlySick =
//                                                     String(l.medical_doc_status) === '1' ||
//                                                     (l.leavetype === 'Sick Leave' &&
//                                                         String(l.medical_doc_status) === '0');

//                                                 const nextType = isCurrentlySick
//                                                     ? "Earned Leave"
//                                                     : "Sick Leave";

//                                                 const nextStatusCode = isCurrentlySick
//                                                     ? 2
//                                                     : 1;

//                                                 if (
//                                                     window.confirm(
//                                                         `Do you want to convert this leave to ${nextType}?`
//                                                     )
//                                                 ) {
//                                                     handleMedicalAction(
//                                                         l.leave_id || l.id,
//                                                         nextStatusCode
//                                                     );
//                                                 }
//                                             }}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '20px',
//                                                 marginTop: '-10px'
//                                             }}
//                                         >
//                                             🔄
//                                         </button>
//                                     </td>



//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle',
//                                             //  marginTop: '-20px'
//                                         }}
//                                     >
//                                         {(l.Status !== '0' && l.Status !== null) && (
//                                             <button
//                                                 className="btn-delete-simple"
//                                                 onClick={() => handleDeleteLeave(l.id)}
//                                                 style={{
//                                                     background: 'none',
//                                                     border: '6px',
//                                                     padding: '0',
//                                                     cursor: 'pointer',
//                                                     fontSize: '22px',
//                                                     opacity: '0.8',
//                                                     transition: 'opacity 0.2s, transform 0.2s',
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     marginTop: '-14px'
//                                                 }}
//                                                 onMouseOver={(e) => {
//                                                     e.currentTarget.style.opacity = '1';
//                                                     e.currentTarget.style.transform = 'scale(1.1)';
//                                                 }}
//                                                 onMouseOut={(e) => {
//                                                     e.currentTarget.style.opacity = '0.8';
//                                                     e.currentTarget.style.transform = 'scale(1)';
//                                                 }}
//                                             >
//                                                 🗑️


//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>



//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_LEAVE_QUOTA
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

//                             {/* <input
//                                 type="text"
//                                 placeholder="Search Employee..."
//                                 className="filter-select"
//                                 value={summarySearch}
//                                 onChange={(e) => setSummarySearch(e.target.value)}
//                                 style={{ width: '220px', fontSize: '12px' }}
//                             /> */}
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {leaveBalances.map((emp, idx) => (
//                         <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
//                             <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
//                             <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
//                                 {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
//                             </div>

//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
//                                 {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
//                             </div>
//                         </div>
//                     ))}
//                     {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeaveManagement;






















// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';

// const LeaveManagement = () => {
//     const navigate = useNavigate();
//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
//     const [pendingWFH, setPendingWFH] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     useEffect(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, []);

//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;

//     const teams = useMemo(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         return isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//     }, [dashboardDepartments]);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return leaves.filter(l => l.Status === '0' || l.Status === null).length;
//     }, [leaves]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             // const storedUser = localStorage.getItem('user');
//             const storedUser = localStorage.getItem('userData');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
//                 credentials: "include"
//             });

//             const data = await res.json();



//             if (data.success) {
//                 setLeaves(data.leaves);
//                 setAllEmployees(data.employees);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 await fetchData(); // Refresh list
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {
//         const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
//         const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
//         setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {
//         const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
//         if (!targetId) {
//             alert("Error: No leave record selected.");
//             return;
//         }
//         const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
//         setProcessing(true);
//         try {
//             let authUser = {};
//             try {
//                 authUser = JSON.parse(localStorage.getItem('user')) ||
//                     JSON.parse(localStorage.getItem('userData')) ||
//                     JSON.parse(localStorage.getItem('employee')) ||
//                     JSON.parse(localStorage.getItem('auth')) || {};
//             } catch (e) { }

//             const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
//             const approverName = authUser.FirstName
//                 ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim()
//                 : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

//             const res = await fetch("/gt-api/update_leave_status.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: targetId,
//                     status: remarkModal.status,
//                     remark: finalRemark,
//                     approved_by_id: approverId,
//                     approved_by_name: approverName
//                 }),
//             });
//             const result = await res.json();
//             if (result.success) {
//                 alert("Leave request successfully " + (remarkModal.status === 1 ? "APPROVED" : "REJECTED") + "!");
//                 setLeaves(prevLeaves => prevLeaves.map(l => {
//                     const lId = l.id || l.leave_id || l.lid;
//                     if (String(lId) === String(targetId)) {
//                         return { ...l, Status: String(remarkModal.status), status: String(remarkModal.status), AdminRemark: finalRemark };
//                     }
//                     return l;
//                 }));
//                 await fetchData();
//                 setRemarkModal({ show: false, id: null, status: null, actionType: "" });
//                 setShowDetailModal(false);
//             } else {
//                 alert("Update failed: " + (result.message || "Server error"));
//             }
//         } catch (e) {
//             alert("Update failed: " + e.message);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const isInProbation = (joiningDate) => {
//         if (!joiningDate) return false;

//         const join = new Date(joiningDate);
//         const probationEnd = new Date(join);
//         probationEnd.setMonth(probationEnd.getMonth() + 6);

//         const today = new Date();

//         return today <= probationEnd;
//     };



//     useEffect(() => {

//         const fetchWFHCount = async () => {
//             try {

//                 const res = await fetch("/gt-api/get_all_wfh_requests.php", {
//                     credentials: "include"
//                 });

//                 const data = await res.json();

//                 if (data.success) {

//                     const pending = data.requests.filter(r => r.status === "Pending").length;

//                     setPendingWFH(pending);

//                 }

//             } catch (err) {

//                 console.error("WFH count fetch error", err);

//             }
//         };

//         fetchWFHCount();

//         const interval = setInterval(fetchWFHCount, 5000);

//         return () => clearInterval(interval);

//     }, []);



//     const leaveBalances = useMemo(() => {
//         const balances = {};
//         const now = new Date();

//         const currentFYStart = now.getMonth() >= 3
//             ? new Date(now.getFullYear(), 3, 1)
//             : new Date(now.getFullYear() - 1, 3, 1);

//         const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

//         // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
//         allEmployees.forEach(emp => {

//             if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

//             const joinDate = new Date(emp.JoiningDate);

//             let sickMonths = 12;
//             if (joinDate > currentFYStart) {
//                 sickMonths =
//                     3 - joinDate.getMonth() +
//                     12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
//             }

//             balances[emp.EmailId] = {
//                 email: emp.EmailId,
//                 name: emp.full_name,
//                 dept: emp.Department,
//                 sick: 0,
//                 sickQuota: sickMonths,
//                 earned: 0,
//                 maxEarned: Number(emp.Earnedcount) || 0
//             };
//         });

//         // ✅ STEP 2: APPLY LEAVES
//         leaves.forEach(l => {

//             const empKey = l.EmailId;
//             if (!balances[empKey]) return;

//             if (l.Status === '1') {

//                 const days = parseFloat(l.total) || 0;
//                 const type = l.leavetype?.toLowerCase() || "";
//                 const medStatus = String(l.medical_doc_status);
//                 const leaveDate = new Date(l.fromdate);

//                 // Sick leave (FY)
//                 if (
//                     leaveDate >= currentFYStart &&
//                     leaveDate <= currentFYEnd &&
//                     type.includes('sick') &&
//                     medStatus !== '2'
//                 ) {
//                     balances[empKey].sick += days;
//                 }

//                 // Earned leave
//                 if (
//                     (type.includes('earned') && medStatus !== '1') ||
//                     (type.includes('sick') && medStatus === '2')
//                 ) {
//                     balances[empKey].earned += days;
//                 }
//             }
//         });

//         return Object.values(balances).filter(emp =>
//             !summarySearch ||
//             emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
//         );

//     }, [leaves, allEmployees, summarySearch, summaryDepartment]);

//     const chartData = useMemo(() => {
//         const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

//         return teamsToDisplay.map(team => {
//             const teamFilteredLeaves = leaves.filter(l => {
//                 const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

//                 return l.Department === team && matchesMonth && matchesYear;
//             });

//             return {
//                 name: team,

//                 // ✅ SUM of leave units instead of count
//                 Approved: teamFilteredLeaves
//                     .filter(l => l.Status === '1')
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: teamFilteredLeaves
//                     .filter(l => (l.Status === '0' || l.Status === null))
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });
//     }, [leaves, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === '1') return 'Approved';
//         if (status === '2') return 'Rejected';
//         return 'Pending';
//     };

//     const filteredTableData = leaves.filter(l => {
//         const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//         const matchesDept = filters.department === 'All' || l.Department === filters.department;
//         const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//         const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//         const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
//             (l.empid && l.empid.toString().includes(searchTerm));
//         return matchesDept && matchesMonth && matchesYear && matchesSearch;
//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body detail-grid" style={{
//                             padding: '20px',
//                             overflowY: 'auto',
//                             flex: 1,
//                             scrollbarWidth: 'thin',
//                             scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
//                         }}>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>LEAVE TYPE:</strong> {
//                                     (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
//                                         ? 'Sick Leave (Medical Approved)'
//                                         : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
//                                             ? 'Earned Leave (Converted)'
//                                             : selectedLeave.leavetype
//                                 }
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
//                             </p>

//                             <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
//                                 <strong>REASON:</strong>
//                                 <div style={{
//                                     marginTop: '8px',
//                                     color: '#ccc',
//                                     lineHeight: '1.5',

//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'pre-wrap',
//                                     overflowWrap: 'break-word'
//                                 }}>
//                                     {selectedLeave.description || 'N/A'}
//                                 </div>
//                             </div>

//                             {(selectedLeave.proof || selectedLeave.medical_doc) && (
//                                 <div className="medical-review-panel" style={{
//                                     marginTop: '20px',
//                                     padding: '15px',
//                                     border: '1px solid #00ff9d',
//                                     borderRadius: '8px',
//                                     background: 'rgba(0, 255, 157, 0.05)',
//                                     marginBottom: '20px'
//                                 }}>
//                                     <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
//                                         DOCUMENTATION_REVIEW
//                                     </h4>

//                                     <img
//                                         src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
//                                         alt="Proof"
//                                         style={{
//                                             width: '100%',
//                                             maxHeight: '300px',
//                                             objectFit: 'contain',
//                                             marginBottom: '15px',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer',
//                                             border: '1px solid #333'
//                                         }}
//                                         onClick={() =>
//                                             window.open(
//                                                 `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
//                                                 '_blank'
//                                             )
//                                         }
//                                     />

//                                     {/* Only show status — no approve/reject buttons */}
//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '10px',
//                                         border: '1px solid #333',
//                                         borderRadius: '4px',
//                                         background: 'rgba(0,0,0,0.3)'
//                                     }}>
//                                         <span style={{
//                                             fontSize: '11px',
//                                             fontWeight: '800',
//                                             color:
//                                                 String(selectedLeave.medical_doc_status) === '1'
//                                                     ? '#00ff9d'
//                                                     : String(selectedLeave.medical_doc_status) === '2'
//                                                         ? '#ff4d4d'
//                                                         : '#ccc'
//                                         }}>
//                                             {String(selectedLeave.medical_doc_status) === '1'
//                                                 ? 'VERIFIED AS SICK LEAVE'
//                                                 : String(selectedLeave.medical_doc_status) === '2'
//                                                     ? 'REJECTED (REMAINS EARNED)'
//                                                     : 'PENDING REVIEW'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}



//                         </div>


//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
//                                 <div className="modal-footer-actions">
//                                     <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
//                                     <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                             <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
//                             <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
//                                 {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = leaves.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
//                         style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
//                     >

//                         {pendingWFH > 0 && (
//                             <span
//                                 style={{
//                                     position: "absolute",
//                                     top: "8px",
//                                     right: "10px",
//                                     background: "#ff4d4d",
//                                     color: "#fff",
//                                     fontSize: "12px",
//                                     fontWeight: "700",
//                                     padding: "3px 7px",
//                                     borderRadius: "12px",
//                                     lineHeight: "1",
//                                     marginTop: "27px",
//                                 }}
//                             >
//                                 {pendingWFH}
//                             </span>
//                         )}

//                         <h4 className="cyan-text">WFH_REQUESTS</h4>

//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>
//                                 {/* VIEW_WFH_REQUESTS */}
//                             </span>
//                         </div>

//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
//                         <h4 className="cyan-text">
//                             {"MEDICAL_REPORTS"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">

//                         </div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/leave-report')}
//                         style={{
//                             cursor: 'pointer',
//                             borderLeft: '4px solid #8b5cf6'
//                         }}
//                     >
//                         <h4 className="cyan-text">
//                             {"GENERATE_REPORT"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">
//                         </div>
//                     </div>
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>




//                 <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>

//                         <tr>

//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 EMPLOYEE
//                             </th>
//                             <th style={{ width: '170px', textAlign: 'left', padding: '12px' }}>
//                                 DEPT
//                             </th>
//                             <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
//                                 TYPE
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 FROM
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 TO
//                             </th>

//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 UNIT
//                             </th>
//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>
//                                 STATUS
//                             </th>
//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 REVIEW
//                             </th>

//                             <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                                 LEAVE CONVERT
//                             </th>



//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 ACTION
//                             </th>
//                         </tr>

//                     </thead>
//                     <tbody>
//                         {currentEntries.map((l, i) => {
//                             const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
//                             const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

//                             return (
//                                 <tr key={i} className="row-hover">

//                                     <td
//                                         className="emp-name-cell"
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '4px'
//                                             }}
//                                         >
//                                             {l.FirstName} {l.LastName}

//                                             {isInProbation(l.JoiningDate) && (
//                                                 <span
//                                                     className="probation-badge"
//                                                     style={{
//                                                         width: 'fit-content',
//                                                         padding: '2px 8px',
//                                                         fontSize: '11px'
//                                                     }}
//                                                 >
//                                                     PROBATION
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.Department}
//                                     </td>






//                                     <td
//                                         style={{
//                                             position: 'relative',
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <div style={{
//                                                 color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 {/* The primary name toggle */}
//                                                 {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
//                                                     String(l.medical_doc_status) === '2' ? 'Earned Leave' :
//                                                         l.leavetype}

//                                                 {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
//                                                 {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
//                                                     <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
//                                                         (MEDICAL APPROVED)
//                                                     </small>
//                                                 )}
//                                             </div>


//                                         </div>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.fromdate}
//                                     </td>
//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.todate}
//                                     </td>

//                                     <td
//                                         style={{
//                                             fontWeight: 'bold',
//                                             color: '#00fff2',
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {parseFloat(l.total)}
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                             {getStatusLabel(l.Status)}
//                                         </span>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '8px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
//                                             <button
//                                                 className="info-btn-circle"
//                                                 onClick={() => {
//                                                     setSelectedLeave(l);
//                                                     setShowDetailModal(true);
//                                                 }}
//                                             >
//                                                 <span className="info-icon">i</span>
//                                             </button>
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <button
//                                             className="convert-type-btn"
//                                             title="Toggle Leave Type"
//                                             onClick={() => {
//                                                 const isCurrentlySick =
//                                                     String(l.medical_doc_status) === '1' ||
//                                                     (l.leavetype === 'Sick Leave' &&
//                                                         String(l.medical_doc_status) === '0');

//                                                 const nextType = isCurrentlySick
//                                                     ? "Earned Leave"
//                                                     : "Sick Leave";

//                                                 const nextStatusCode = isCurrentlySick
//                                                     ? 2
//                                                     : 1;

//                                                 if (
//                                                     window.confirm(
//                                                         `Do you want to convert this leave to ${nextType}?`
//                                                     )
//                                                 ) {
//                                                     handleMedicalAction(
//                                                         l.leave_id || l.id,
//                                                         nextStatusCode
//                                                     );
//                                                 }
//                                             }}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '20px',
//                                                 marginTop: '-10px'
//                                             }}
//                                         >
//                                             🔄
//                                         </button>
//                                     </td>



//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle',
//                                             //  marginTop: '-20px'
//                                         }}
//                                     >
//                                         {(l.Status !== '0' && l.Status !== null) && (
//                                             <button
//                                                 className="btn-delete-simple"
//                                                 onClick={() => handleDeleteLeave(l.id)}
//                                                 style={{
//                                                     background: 'none',
//                                                     border: '6px',
//                                                     padding: '0',
//                                                     cursor: 'pointer',
//                                                     fontSize: '22px',
//                                                     opacity: '0.8',
//                                                     transition: 'opacity 0.2s, transform 0.2s',
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     marginTop: '-14px'
//                                                 }}
//                                                 onMouseOver={(e) => {
//                                                     e.currentTarget.style.opacity = '1';
//                                                     e.currentTarget.style.transform = 'scale(1.1)';
//                                                 }}
//                                                 onMouseOut={(e) => {
//                                                     e.currentTarget.style.opacity = '0.8';
//                                                     e.currentTarget.style.transform = 'scale(1)';
//                                                 }}
//                                             >
//                                                 🗑️


//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>



//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_LEAVE_QUOTA
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

//                             {/* <input
//                                 type="text"
//                                 placeholder="Search Employee..."
//                                 className="filter-select"
//                                 value={summarySearch}
//                                 onChange={(e) => setSummarySearch(e.target.value)}
//                                 style={{ width: '220px', fontSize: '12px' }}
//                             /> */}
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {leaveBalances.map((emp, idx) => (
//                         <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
//                             <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
//                             <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
//                                 {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
//                             </div>

//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
//                                 {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
//                             </div>
//                         </div>
//                     ))}
//                     {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeaveManagement;



























// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';

// const LeaveManagement = () => {
//     const navigate = useNavigate();
//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
//     const [pendingWFH, setPendingWFH] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     useEffect(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, []);

//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;

//     const teams = useMemo(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         return isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//     }, [dashboardDepartments]);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return leaves.filter(l => l.Status === '0' || l.Status === null).length;
//     }, [leaves]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             // const storedUser = localStorage.getItem('user');
//             const storedUser = localStorage.getItem('userData');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
//                 credentials: "include"
//             });

//             const data = await res.json();



//             if (data.success) {
//                 setLeaves(data.leaves);
//                 setAllEmployees(data.employees);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 fetchData(); // Refresh list in background
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {
//         const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
//         const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
//         setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {
//         const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
//         if (!targetId) {
//             alert("Error: No leave record selected.");
//             return;
//         }
//         const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
//         const statusVal = remarkModal.status;

//         // 1. Instantly update UI locally (Optimistic update)
//         setLeaves(prevLeaves => prevLeaves.map(l => {
//             const lId = l.id || l.leave_id || l.lid;
//             if (String(lId) === String(targetId)) {
//                 return { ...l, Status: String(statusVal), status: String(statusVal), AdminRemark: finalRemark };
//             }
//             return l;
//         }));

//         // 2. Instantly close both modals & reset remark state
//         setRemarkModal({ show: false, id: null, status: null, actionType: "" });
//         setShowDetailModal(false);

//         // 3. Send update request to server in background without blocking UI
//         try {
//             let authUser = {};
//             try {
//                 authUser = JSON.parse(localStorage.getItem('user')) ||
//                     JSON.parse(localStorage.getItem('userData')) ||
//                     JSON.parse(localStorage.getItem('employee')) ||
//                     JSON.parse(localStorage.getItem('auth')) || {};
//             } catch (e) { }

//             const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
//             const approverName = authUser.FirstName
//                 ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim()
//                 : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

//             fetch("/gt-api/update_leave_status.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: targetId,
//                     status: statusVal,
//                     remark: finalRemark,
//                     approved_by_id: approverId,
//                     approved_by_name: approverName
//                 }),
//             }).then(res => res.json()).then(result => {
//                 if (!result.success) {
//                     alert("Update failed: " + (result.message || "Server error"));
//                     fetchData();
//                 } else {
//                     fetchData();
//                 }
//             }).catch(err => {
//                 console.error("Leave update background error:", err);
//                 fetchData();
//             });
//         } catch (e) {
//             console.error("Error sending leave update:", e);
//         }
//     };

//     const isInProbation = (joiningDate) => {
//         if (!joiningDate) return false;

//         const join = new Date(joiningDate);
//         const probationEnd = new Date(join);
//         probationEnd.setMonth(probationEnd.getMonth() + 6);

//         const today = new Date();

//         return today <= probationEnd;
//     };



//     useEffect(() => {

//         const fetchWFHCount = async () => {
//             try {

//                 const res = await fetch("/gt-api/get_all_wfh_requests.php", {
//                     credentials: "include"
//                 });

//                 const data = await res.json();

//                 if (data.success) {

//                     const pending = data.requests.filter(r => r.status === "Pending").length;

//                     setPendingWFH(pending);

//                 }

//             } catch (err) {

//                 console.error("WFH count fetch error", err);

//             }
//         };

//         fetchWFHCount();

//         const interval = setInterval(fetchWFHCount, 5000);

//         return () => clearInterval(interval);

//     }, []);



//     const leaveBalances = useMemo(() => {
//         const balances = {};
//         const now = new Date();

//         const currentFYStart = now.getMonth() >= 3
//             ? new Date(now.getFullYear(), 3, 1)
//             : new Date(now.getFullYear() - 1, 3, 1);

//         const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

//         // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
//         allEmployees.forEach(emp => {

//             if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

//             const joinDate = new Date(emp.JoiningDate);

//             let sickMonths = 12;
//             if (joinDate > currentFYStart) {
//                 sickMonths =
//                     3 - joinDate.getMonth() +
//                     12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
//             }

//             balances[emp.EmailId] = {
//                 email: emp.EmailId,
//                 name: emp.full_name,
//                 dept: emp.Department,
//                 sick: 0,
//                 sickQuota: sickMonths,
//                 earned: 0,
//                 maxEarned: Number(emp.Earnedcount) || 0
//             };
//         });

//         // ✅ STEP 2: APPLY LEAVES
//         leaves.forEach(l => {

//             const empKey = l.EmailId;
//             if (!balances[empKey]) return;

//             if (l.Status === '1') {

//                 const days = parseFloat(l.total) || 0;
//                 const type = l.leavetype?.toLowerCase() || "";
//                 const medStatus = String(l.medical_doc_status);
//                 const leaveDate = new Date(l.fromdate);

//                 // Sick leave (FY)
//                 if (
//                     leaveDate >= currentFYStart &&
//                     leaveDate <= currentFYEnd &&
//                     type.includes('sick') &&
//                     medStatus !== '2'
//                 ) {
//                     balances[empKey].sick += days;
//                 }

//                 // Earned leave
//                 if (
//                     (type.includes('earned') && medStatus !== '1') ||
//                     (type.includes('sick') && medStatus === '2')
//                 ) {
//                     balances[empKey].earned += days;
//                 }
//             }
//         });

//         return Object.values(balances).filter(emp =>
//             !summarySearch ||
//             emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
//         );

//     }, [leaves, allEmployees, summarySearch, summaryDepartment]);

//     const chartData = useMemo(() => {
//         const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

//         return teamsToDisplay.map(team => {
//             const teamFilteredLeaves = leaves.filter(l => {
//                 const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

//                 return l.Department === team && matchesMonth && matchesYear;
//             });

//             return {
//                 name: team,

//                 // ✅ SUM of leave units instead of count
//                 Approved: teamFilteredLeaves
//                     .filter(l => l.Status === '1')
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: teamFilteredLeaves
//                     .filter(l => (l.Status === '0' || l.Status === null))
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });
//     }, [leaves, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === '1') return 'Approved';
//         if (status === '2') return 'Rejected';
//         return 'Pending';
//     };

//     const filteredTableData = leaves.filter(l => {
//         const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//         const matchesDept = filters.department === 'All' || l.Department === filters.department;
//         const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//         const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//         const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
//             (l.empid && l.empid.toString().includes(searchTerm));
//         return matchesDept && matchesMonth && matchesYear && matchesSearch;
//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body detail-grid" style={{
//                             padding: '20px',
//                             overflowY: 'auto',
//                             flex: 1,
//                             scrollbarWidth: 'thin',
//                             scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
//                         }}>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>LEAVE TYPE:</strong> {
//                                     (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
//                                         ? 'Sick Leave (Medical Approved)'
//                                         : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
//                                             ? 'Earned Leave (Converted)'
//                                             : selectedLeave.leavetype
//                                 }
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
//                             </p>

//                             <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
//                                 <strong>REASON:</strong>
//                                 <div style={{
//                                     marginTop: '8px',
//                                     color: '#ccc',
//                                     lineHeight: '1.5',

//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'pre-wrap',
//                                     overflowWrap: 'break-word'
//                                 }}>
//                                     {selectedLeave.description || 'N/A'}
//                                 </div>
//                             </div>

//                             {(selectedLeave.proof || selectedLeave.medical_doc) && (
//                                 <div className="medical-review-panel" style={{
//                                     marginTop: '20px',
//                                     padding: '15px',
//                                     border: '1px solid #00ff9d',
//                                     borderRadius: '8px',
//                                     background: 'rgba(0, 255, 157, 0.05)',
//                                     marginBottom: '20px'
//                                 }}>
//                                     <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
//                                         DOCUMENTATION_REVIEW
//                                     </h4>

//                                     <img
//                                         src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
//                                         alt="Proof"
//                                         style={{
//                                             width: '100%',
//                                             maxHeight: '300px',
//                                             objectFit: 'contain',
//                                             marginBottom: '15px',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer',
//                                             border: '1px solid #333'
//                                         }}
//                                         onClick={() =>
//                                             window.open(
//                                                 `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
//                                                 '_blank'
//                                             )
//                                         }
//                                     />

//                                     {/* Only show status — no approve/reject buttons */}
//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '10px',
//                                         border: '1px solid #333',
//                                         borderRadius: '4px',
//                                         background: 'rgba(0,0,0,0.3)'
//                                     }}>
//                                         <span style={{
//                                             fontSize: '11px',
//                                             fontWeight: '800',
//                                             color:
//                                                 String(selectedLeave.medical_doc_status) === '1'
//                                                     ? '#00ff9d'
//                                                     : String(selectedLeave.medical_doc_status) === '2'
//                                                         ? '#ff4d4d'
//                                                         : '#ccc'
//                                         }}>
//                                             {String(selectedLeave.medical_doc_status) === '1'
//                                                 ? 'VERIFIED AS SICK LEAVE'
//                                                 : String(selectedLeave.medical_doc_status) === '2'
//                                                     ? 'REJECTED (REMAINS EARNED)'
//                                                     : 'PENDING REVIEW'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}



//                         </div>


//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
//                                 <div className="modal-footer-actions">
//                                     <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
//                                     <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                             <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
//                             <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
//                                 {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = leaves.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
//                         style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
//                     >

//                         {pendingWFH > 0 && (
//                             <span
//                                 style={{
//                                     position: "absolute",
//                                     top: "8px",
//                                     right: "10px",
//                                     background: "#ff4d4d",
//                                     color: "#fff",
//                                     fontSize: "12px",
//                                     fontWeight: "700",
//                                     padding: "3px 7px",
//                                     borderRadius: "12px",
//                                     lineHeight: "1",
//                                     marginTop: "27px",
//                                 }}
//                             >
//                                 {pendingWFH}
//                             </span>
//                         )}

//                         <h4 className="cyan-text">WFH_REQUESTS</h4>

//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>
//                                 {/* VIEW_WFH_REQUESTS */}
//                             </span>
//                         </div>

//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
//                         <h4 className="cyan-text">
//                             {"MEDICAL_REPORTS"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">

//                         </div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/leave-report')}
//                         style={{
//                             cursor: 'pointer',
//                             borderLeft: '4px solid #8b5cf6'
//                         }}
//                     >
//                         <h4 className="cyan-text">
//                             {"GENERATE_REPORT"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">
//                         </div>
//                     </div>
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>




//                 <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>

//                         <tr>

//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 EMPLOYEE
//                             </th>
//                             <th style={{ width: '170px', textAlign: 'left', padding: '12px' }}>
//                                 DEPT
//                             </th>
//                             <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
//                                 TYPE
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 FROM
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 TO
//                             </th>

//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 UNIT
//                             </th>
//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>
//                                 STATUS
//                             </th>
//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 REVIEW
//                             </th>

//                             <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                                 LEAVE CONVERT
//                             </th>



//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 ACTION
//                             </th>
//                         </tr>

//                     </thead>
//                     <tbody>
//                         {currentEntries.map((l, i) => {
//                             const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
//                             const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

//                             return (
//                                 <tr key={i} className="row-hover">

//                                     <td
//                                         className="emp-name-cell"
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '4px'
//                                             }}
//                                         >
//                                             {l.FirstName} {l.LastName}

//                                             {isInProbation(l.JoiningDate) && (
//                                                 <span
//                                                     className="probation-badge"
//                                                     style={{
//                                                         width: 'fit-content',
//                                                         padding: '2px 8px',
//                                                         fontSize: '11px'
//                                                     }}
//                                                 >
//                                                     PROBATION
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.Department}
//                                     </td>






//                                     <td
//                                         style={{
//                                             position: 'relative',
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <div style={{
//                                                 color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 {/* The primary name toggle */}
//                                                 {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
//                                                     String(l.medical_doc_status) === '2' ? 'Earned Leave' :
//                                                         l.leavetype}

//                                                 {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
//                                                 {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
//                                                     <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
//                                                         (MEDICAL APPROVED)
//                                                     </small>
//                                                 )}
//                                             </div>


//                                         </div>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.fromdate}
//                                     </td>
//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.todate}
//                                     </td>

//                                     <td
//                                         style={{
//                                             fontWeight: 'bold',
//                                             color: '#00fff2',
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {parseFloat(l.total)}
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                             {getStatusLabel(l.Status)}
//                                         </span>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '8px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
//                                             <button
//                                                 className="info-btn-circle"
//                                                 onClick={() => {
//                                                     setSelectedLeave(l);
//                                                     setShowDetailModal(true);
//                                                 }}
//                                             >
//                                                 <span className="info-icon">i</span>
//                                             </button>
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <button
//                                             className="convert-type-btn"
//                                             title="Toggle Leave Type"
//                                             onClick={() => {
//                                                 const isCurrentlySick =
//                                                     String(l.medical_doc_status) === '1' ||
//                                                     (l.leavetype === 'Sick Leave' &&
//                                                         String(l.medical_doc_status) === '0');

//                                                 const nextType = isCurrentlySick
//                                                     ? "Earned Leave"
//                                                     : "Sick Leave";

//                                                 const nextStatusCode = isCurrentlySick
//                                                     ? 2
//                                                     : 1;

//                                                 if (
//                                                     window.confirm(
//                                                         `Do you want to convert this leave to ${nextType}?`
//                                                     )
//                                                 ) {
//                                                     handleMedicalAction(
//                                                         l.leave_id || l.id,
//                                                         nextStatusCode
//                                                     );
//                                                 }
//                                             }}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '20px',
//                                                 marginTop: '-10px'
//                                             }}
//                                         >
//                                             🔄
//                                         </button>
//                                     </td>



//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle',
//                                             //  marginTop: '-20px'
//                                         }}
//                                     >
//                                         {(l.Status !== '0' && l.Status !== null) && (
//                                             <button
//                                                 className="btn-delete-simple"
//                                                 onClick={() => handleDeleteLeave(l.id)}
//                                                 style={{
//                                                     background: 'none',
//                                                     border: '6px',
//                                                     padding: '0',
//                                                     cursor: 'pointer',
//                                                     fontSize: '22px',
//                                                     opacity: '0.8',
//                                                     transition: 'opacity 0.2s, transform 0.2s',
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     marginTop: '-14px'
//                                                 }}
//                                                 onMouseOver={(e) => {
//                                                     e.currentTarget.style.opacity = '1';
//                                                     e.currentTarget.style.transform = 'scale(1.1)';
//                                                 }}
//                                                 onMouseOut={(e) => {
//                                                     e.currentTarget.style.opacity = '0.8';
//                                                     e.currentTarget.style.transform = 'scale(1)';
//                                                 }}
//                                             >
//                                                 🗑️


//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>



//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_LEAVE_QUOTA
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

//                             {/* <input
//                                 type="text"
//                                 placeholder="Search Employee..."
//                                 className="filter-select"
//                                 value={summarySearch}
//                                 onChange={(e) => setSummarySearch(e.target.value)}
//                                 style={{ width: '220px', fontSize: '12px' }}
//                             /> */}
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {leaveBalances.map((emp, idx) => (
//                         <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
//                             <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
//                             <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
//                                 {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
//                             </div>

//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
//                                 {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
//                             </div>
//                         </div>
//                     ))}
//                     {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeaveManagement;


































// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';

// const LeaveManagement = () => {
//     const navigate = useNavigate();
//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
//     const [pendingWFH, setPendingWFH] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     useEffect(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, []);

//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;

//     const teams = useMemo(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         return isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//     }, [dashboardDepartments]);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return leaves.filter(l => l.Status === '0' || l.Status === null).length;
//     }, [leaves]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             // const storedUser = localStorage.getItem('user');
//             const storedUser = localStorage.getItem('userData');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
//                 credentials: "include"
//             });

//             const data = await res.json();



//             if (data.success) {
//                 setLeaves(data.leaves);
//                 setAllEmployees(data.employees);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 fetchData(); // Refresh list in background
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {
//         const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
//         const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
//         setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {
//         const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
//         if (!targetId) {
//             alert("Error: No leave record selected.");
//             return;
//         }
//         const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
//         const statusVal = remarkModal.status;

//         // 1. Instantly update UI locally (Optimistic update)
//         setLeaves(prevLeaves => prevLeaves.map(l => {
//             const lId = l.id || l.leave_id || l.lid;
//             if (String(lId) === String(targetId)) {
//                 return { ...l, Status: String(statusVal), status: String(statusVal), AdminRemark: finalRemark };
//             }
//             return l;
//         }));

//         // 2. Instantly close both modals & reset remark state
//         setRemarkModal({ show: false, id: null, status: null, actionType: "" });
//         setShowDetailModal(false);

//         // 3. Send update request to server in background without blocking UI
//         try {
//             let authUser = {};
//             try {
//                 authUser = JSON.parse(localStorage.getItem('user')) ||
//                     JSON.parse(localStorage.getItem('userData')) ||
//                     JSON.parse(localStorage.getItem('employee')) ||
//                     JSON.parse(localStorage.getItem('auth')) || {};
//             } catch (e) { }

//             const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
//             const approverName = authUser.FirstName
//                 ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim()
//                 : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

//             fetch("/gt-api/update_leave_status.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: targetId,
//                     status: statusVal,
//                     remark: finalRemark,
//                     approved_by_id: approverId,
//                     approved_by_name: approverName
//                 }),
//             }).then(res => res.json()).then(result => {
//                 if (!result.success) {
//                     alert("Update failed: " + (result.message || "Server error"));
//                     fetchData();
//                 } else {
//                     fetchData();
//                 }
//             }).catch(err => {
//                 console.error("Leave update background error:", err);
//                 fetchData();
//             });
//         } catch (e) {
//             console.error("Error sending leave update:", e);
//         }
//     };

//     const isInProbation = (joiningDate) => {
//         if (!joiningDate) return false;

//         const join = new Date(joiningDate);
//         const probationEnd = new Date(join);
//         probationEnd.setMonth(probationEnd.getMonth() + 6);

//         const today = new Date();

//         return today <= probationEnd;
//     };



//     useEffect(() => {

//         const fetchWFHCount = async () => {
//             try {

//                 const res = await fetch("/gt-api/get_all_wfh_requests.php", {
//                     credentials: "include"
//                 });

//                 const data = await res.json();

//                 if (data.success) {

//                     const pending = data.requests.filter(r => r.status === "Pending").length;

//                     setPendingWFH(pending);

//                 }

//             } catch (err) {

//                 console.error("WFH count fetch error", err);

//             }
//         };

//         fetchWFHCount();

//         const interval = setInterval(fetchWFHCount, 5000);

//         return () => clearInterval(interval);

//     }, []);



//     const leaveBalances = useMemo(() => {
//         const balances = {};
//         const now = new Date();

//         const currentFYStart = now.getMonth() >= 3
//             ? new Date(now.getFullYear(), 3, 1)
//             : new Date(now.getFullYear() - 1, 3, 1);

//         const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

//         // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
//         allEmployees.forEach(emp => {

//             if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

//             const joinDate = new Date(emp.JoiningDate);

//             let sickMonths = 12;
//             if (joinDate > currentFYStart) {
//                 sickMonths =
//                     3 - joinDate.getMonth() +
//                     12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
//             }

//             balances[emp.EmailId] = {
//                 email: emp.EmailId,
//                 name: emp.full_name,
//                 dept: emp.Department,
//                 sick: 0,
//                 sickQuota: sickMonths,
//                 earned: 0,
//                 maxEarned: Number(emp.Earnedcount) || 0
//             };
//         });

//         // ✅ STEP 2: APPLY LEAVES
//         leaves.forEach(l => {

//             const empKey = l.EmailId;
//             if (!balances[empKey]) return;

//             if (l.Status === '1') {

//                 const days = parseFloat(l.total) || 0;
//                 const type = l.leavetype?.toLowerCase() || "";
//                 const medStatus = String(l.medical_doc_status);
//                 const leaveDate = new Date(l.fromdate);

//                 // Sick leave (FY)
//                 if (
//                     leaveDate >= currentFYStart &&
//                     leaveDate <= currentFYEnd &&
//                     type.includes('sick') &&
//                     medStatus !== '2'
//                 ) {
//                     balances[empKey].sick += days;
//                 }

//                 // Earned leave
//                 if (
//                     (type.includes('earned') && medStatus !== '1') ||
//                     (type.includes('sick') && medStatus === '2')
//                 ) {
//                     balances[empKey].earned += days;
//                 }
//             }
//         });

//         return Object.values(balances).filter(emp =>
//             !summarySearch ||
//             emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
//         );

//     }, [leaves, allEmployees, summarySearch, summaryDepartment]);

//     const chartData = useMemo(() => {
//         const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

//         return teamsToDisplay.map(team => {
//             const teamFilteredLeaves = leaves.filter(l => {
//                 const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

//                 return l.Department === team && matchesMonth && matchesYear;
//             });

//             return {
//                 name: team,

//                 // ✅ SUM of leave units instead of count
//                 Approved: teamFilteredLeaves
//                     .filter(l => l.Status === '1')
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: teamFilteredLeaves
//                     .filter(l => (l.Status === '0' || l.Status === null))
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });
//     }, [leaves, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === '1') return 'Approved';
//         if (status === '2') return 'Rejected';
//         return 'Pending';
//     };

//     const filteredTableData = leaves.filter(l => {
//         const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//         const matchesDept = filters.department === 'All' || l.Department === filters.department;
//         const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//         const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//         const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
//             (l.empid && l.empid.toString().includes(searchTerm));
//         return matchesDept && matchesMonth && matchesYear && matchesSearch;
//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body detail-grid" style={{
//                             padding: '20px',
//                             overflowY: 'auto',
//                             flex: 1,
//                             scrollbarWidth: 'thin',
//                             scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
//                         }}>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>LEAVE TYPE:</strong> {
//                                     (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
//                                         ? 'Sick Leave (Medical Approved)'
//                                         : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
//                                             ? 'Earned Leave (Converted)'
//                                             : selectedLeave.leavetype
//                                 }
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
//                             </p>

//                             <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
//                                 <strong>REASON:</strong>
//                                 <div style={{
//                                     marginTop: '8px',
//                                     color: '#ccc',
//                                     lineHeight: '1.5',

//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'pre-wrap',
//                                     overflowWrap: 'break-word'
//                                 }}>
//                                     {selectedLeave.description || 'N/A'}
//                                 </div>
//                             </div>

//                             {(selectedLeave.proof || selectedLeave.medical_doc) && (
//                                 <div className="medical-review-panel" style={{
//                                     marginTop: '20px',
//                                     padding: '15px',
//                                     border: '1px solid #00ff9d',
//                                     borderRadius: '8px',
//                                     background: 'rgba(0, 255, 157, 0.05)',
//                                     marginBottom: '20px'
//                                 }}>
//                                     <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
//                                         DOCUMENTATION_REVIEW
//                                     </h4>

//                                     <img
//                                         src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
//                                         alt="Proof"
//                                         style={{
//                                             width: '100%',
//                                             maxHeight: '300px',
//                                             objectFit: 'contain',
//                                             marginBottom: '15px',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer',
//                                             border: '1px solid #333'
//                                         }}
//                                         onClick={() =>
//                                             window.open(
//                                                 `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
//                                                 '_blank'
//                                             )
//                                         }
//                                     />

//                                     {/* Only show status — no approve/reject buttons */}
//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '10px',
//                                         border: '1px solid #333',
//                                         borderRadius: '4px',
//                                         background: 'rgba(0,0,0,0.3)'
//                                     }}>
//                                         <span style={{
//                                             fontSize: '11px',
//                                             fontWeight: '800',
//                                             color:
//                                                 String(selectedLeave.medical_doc_status) === '1'
//                                                     ? '#00ff9d'
//                                                     : String(selectedLeave.medical_doc_status) === '2'
//                                                         ? '#ff4d4d'
//                                                         : '#ccc'
//                                         }}>
//                                             {String(selectedLeave.medical_doc_status) === '1'
//                                                 ? 'VERIFIED AS SICK LEAVE'
//                                                 : String(selectedLeave.medical_doc_status) === '2'
//                                                     ? 'REJECTED (REMAINS EARNED)'
//                                                     : 'PENDING REVIEW'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}



//                         </div>


//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
//                                 <div className="modal-footer-actions">
//                                     <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
//                                     <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                             <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
//                             <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
//                                 {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = leaves.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
//                         style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
//                     >

//                         {pendingWFH > 0 && (
//                             <span
//                                 style={{
//                                     position: "absolute",
//                                     top: "8px",
//                                     right: "10px",
//                                     background: "#ff4d4d",
//                                     color: "#fff",
//                                     fontSize: "12px",
//                                     fontWeight: "700",
//                                     padding: "3px 7px",
//                                     borderRadius: "12px",
//                                     lineHeight: "1",
//                                     marginTop: "27px",
//                                 }}
//                             >
//                                 {pendingWFH}
//                             </span>
//                         )}

//                         <h4 className="cyan-text">WFH_REQUESTS</h4>

//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>
//                                 {/* VIEW_WFH_REQUESTS */}
//                             </span>
//                         </div>

//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
//                         <h4 className="cyan-text">
//                             {"MEDICAL_REPORTS"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">

//                         </div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/leave-report')}
//                         style={{
//                             cursor: 'pointer',
//                             borderLeft: '4px solid #8b5cf6'
//                         }}
//                     >
//                         <h4 className="cyan-text">
//                             {"GENERATE_REPORT"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">
//                         </div>
//                     </div>
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>




//                 <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>

//                         <tr>

//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 EMPLOYEE
//                             </th>
//                             <th style={{ width: '170px', textAlign: 'left', padding: '12px' }}>
//                                 DEPT
//                             </th>
//                             <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
//                                 TYPE
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 FROM
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 TO
//                             </th>

//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 UNIT
//                             </th>
//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>
//                                 STATUS
//                             </th>
//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 REVIEW
//                             </th>

//                             <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                                 LEAVE CONVERT
//                             </th>



//                             <th style={{ width: '100px', textAlign: 'center', padding: '12px' }}>
//                                 ACTION
//                             </th>
//                         </tr>

//                     </thead>
//                     <tbody>
//                         {currentEntries.map((l, i) => {
//                             const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
//                             const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

//                             return (
//                                 <tr key={i} className="row-hover">

//                                     <td
//                                         className="emp-name-cell"
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '4px'
//                                             }}
//                                         >
//                                             {l.FirstName} {l.LastName}

//                                             {isInProbation(l.JoiningDate) && (
//                                                 <span
//                                                     className="probation-badge"
//                                                     style={{
//                                                         width: 'fit-content',
//                                                         padding: '2px 8px',
//                                                         fontSize: '11px'
//                                                     }}
//                                                 >
//                                                     PROBATION
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.Department}
//                                     </td>






//                                     <td
//                                         style={{
//                                             position: 'relative',
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <div style={{
//                                                 color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 {/* The primary name toggle */}
//                                                 {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
//                                                     String(l.medical_doc_status) === '2' ? 'Earned Leave' :
//                                                         l.leavetype}

//                                                 {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
//                                                 {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
//                                                     <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
//                                                         (MEDICAL APPROVED)
//                                                     </small>
//                                                 )}
//                                             </div>


//                                         </div>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.fromdate}
//                                     </td>
//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.todate}
//                                     </td>

//                                     <td
//                                         style={{
//                                             fontWeight: 'bold',
//                                             color: '#00fff2',
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {parseFloat(l.total)}
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                             {getStatusLabel(l.Status)}
//                                         </span>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '8px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
//                                             <button
//                                                 className="info-btn-circle"
//                                                 onClick={() => {
//                                                     setSelectedLeave(l);
//                                                     setShowDetailModal(true);
//                                                 }}
//                                             >
//                                                 <span className="info-icon">i</span>
//                                             </button>
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <button
//                                             className="convert-type-btn"
//                                             title="Toggle Leave Type"
//                                             onClick={() => {
//                                                 const currentType = String(l.medical_doc_status) === '1'
//                                                     ? 'Sick Leave'
//                                                     : String(l.medical_doc_status) === '2'
//                                                         ? 'Earned Leave'
//                                                         : (l.leavetype || '');

//                                                 const isCurrentlySick = currentType.toLowerCase().includes('sick');

//                                                 const nextType = isCurrentlySick
//                                                     ? "Earned Leave"
//                                                     : "Sick Leave";

//                                                 const nextStatusCode = isCurrentlySick
//                                                     ? 2
//                                                     : 1;

//                                                 if (
//                                                     window.confirm(
//                                                         `Do you want to convert this leave to ${nextType}?`
//                                                     )
//                                                 ) {
//                                                     handleMedicalAction(
//                                                         l.leave_id || l.id,
//                                                         nextStatusCode
//                                                     );
//                                                 }
//                                             }}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '20px',
//                                                 marginTop: '-10px'
//                                             }}
//                                         >
//                                             🔄
//                                         </button>
//                                     </td>



//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle',
//                                             //  marginTop: '-20px'
//                                         }}
//                                     >
//                                         {(l.Status !== '0' && l.Status !== null) && (
//                                             <button
//                                                 className="btn-delete-simple"
//                                                 onClick={() => handleDeleteLeave(l.id)}
//                                                 style={{
//                                                     background: 'none',
//                                                     border: '6px',
//                                                     padding: '0',
//                                                     cursor: 'pointer',
//                                                     fontSize: '22px',
//                                                     opacity: '0.8',
//                                                     transition: 'opacity 0.2s, transform 0.2s',
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     marginTop: '-14px'
//                                                 }}
//                                                 onMouseOver={(e) => {
//                                                     e.currentTarget.style.opacity = '1';
//                                                     e.currentTarget.style.transform = 'scale(1.1)';
//                                                 }}
//                                                 onMouseOut={(e) => {
//                                                     e.currentTarget.style.opacity = '0.8';
//                                                     e.currentTarget.style.transform = 'scale(1)';
//                                                 }}
//                                             >
//                                                 🗑️


//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>



//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_LEAVE_QUOTA
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

//                             {/* <input
//                                 type="text"
//                                 placeholder="Search Employee..."
//                                 className="filter-select"
//                                 value={summarySearch}
//                                 onChange={(e) => setSummarySearch(e.target.value)}
//                                 style={{ width: '220px', fontSize: '12px' }}
//                             /> */}
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {leaveBalances.map((emp, idx) => (
//                         <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
//                             <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
//                             <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
//                                 {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
//                             </div>

//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
//                                 {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
//                             </div>
//                         </div>
//                     ))}
//                     {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeaveManagement;





























// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';

// const LeaveManagement = () => {
//     const navigate = useNavigate();
//     const [leaves, setLeaves] = useState([]);
//     const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
//     const [pendingWFH, setPendingWFH] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");
//     const [dashboardDepartments, setDashboardDepartments] = useState([]);
//     useEffect(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         if (isGenesis) return;

//         fetch(
//             "/gt-api/get_departments.php",
//             {
//                 credentials: "include"
//             }
//         )
//             .then(res => res.json())
//             .then(data => {

//                 if (data.success) {

//                     setDashboardDepartments(
//                         data.departments || []
//                     );

//                 }

//             })
//             .catch(console.error);

//     }, []);

//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;

//     const teams = useMemo(() => {

//         const storedUser =
//             localStorage.getItem("userData");

//         const user =
//             JSON.parse(storedUser || "{}");

//         const email =
//             user?.EmailId || "";

//         const isGenesis =
//             email.toLowerCase().includes("genesistech.co.in") ||
//             email.toLowerCase().includes("gtecorpgroup.com") ||
//             email.toLowerCase().includes("gtcorpgroup.com");

//         return isGenesis

//             ? [
//                 "FI Design",
//                 "FSPLO",
//                 "LTDM PC",
//                 "DDI",
//                 "DMS",
//                 "FI-IE",
//                 "LTO",
//                 "GTE-Technology Operations"
//             ]

//             : dashboardDepartments.map(
//                 dept => dept.DepartmentName
//             );

//     }, [dashboardDepartments]);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return leaves.filter(l => l.Status === '0' || l.Status === null).length;
//     }, [leaves]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             // const storedUser = localStorage.getItem('user');
//             const storedUser = localStorage.getItem('userData');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
//                 credentials: "include"
//             });

//             const data = await res.json();



//             if (data.success) {
//                 setLeaves(data.leaves);
//                 setAllEmployees(data.employees);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 fetchData(); // Refresh list in background
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {
//         const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
//         const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
//         setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {
//         const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
//         if (!targetId) {
//             alert("Error: No leave record selected.");
//             return;
//         }
//         const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
//         const statusVal = remarkModal.status;

//         // 1. Instantly update UI locally (Optimistic update)
//         setLeaves(prevLeaves => prevLeaves.map(l => {
//             const lId = l.id || l.leave_id || l.lid;
//             if (String(lId) === String(targetId)) {
//                 return { ...l, Status: String(statusVal), status: String(statusVal), AdminRemark: finalRemark };
//             }
//             return l;
//         }));

//         // 2. Instantly close both modals & reset remark state
//         setRemarkModal({ show: false, id: null, status: null, actionType: "" });
//         setShowDetailModal(false);

//         // 3. Send update request to server in background without blocking UI
//         try {
//             let authUser = {};
//             try {
//                 authUser = JSON.parse(localStorage.getItem('user')) ||
//                     JSON.parse(localStorage.getItem('userData')) ||
//                     JSON.parse(localStorage.getItem('employee')) ||
//                     JSON.parse(localStorage.getItem('auth')) || {};
//             } catch (e) { }

//             const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
//             const approverName = authUser.FirstName
//                 ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim()
//                 : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

//             fetch("/gt-api/update_leave_status.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: targetId,
//                     status: statusVal,
//                     remark: finalRemark,
//                     approved_by_id: approverId,
//                     approved_by_name: approverName
//                 }),
//             }).then(res => res.json()).then(result => {
//                 if (!result.success) {
//                     alert("Update failed: " + (result.message || "Server error"));
//                     fetchData();
//                 } else {
//                     fetchData();
//                 }
//             }).catch(err => {
//                 console.error("Leave update background error:", err);
//                 fetchData();
//             });
//         } catch (e) {
//             console.error("Error sending leave update:", e);
//         }
//     };

//     const isInProbation = (joiningDate) => {
//         if (!joiningDate) return false;

//         const join = new Date(joiningDate);
//         const probationEnd = new Date(join);
//         probationEnd.setMonth(probationEnd.getMonth() + 6);

//         const today = new Date();

//         return today <= probationEnd;
//     };



//     useEffect(() => {

//         const fetchWFHCount = async () => {
//             try {

//                 const res = await fetch("/gt-api/get_all_wfh_requests.php", {
//                     credentials: "include"
//                 });

//                 const data = await res.json();

//                 if (data.success) {

//                     const pending = data.requests.filter(r => r.status === "Pending").length;

//                     setPendingWFH(pending);

//                 }

//             } catch (err) {

//                 console.error("WFH count fetch error", err);

//             }
//         };

//         fetchWFHCount();

//         const interval = setInterval(fetchWFHCount, 5000);

//         return () => clearInterval(interval);

//     }, []);



//     const leaveBalances = useMemo(() => {
//         const balances = {};
//         const now = new Date();

//         const currentFYStart = now.getMonth() >= 3
//             ? new Date(now.getFullYear(), 3, 1)
//             : new Date(now.getFullYear() - 1, 3, 1);

//         const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

//         // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
//         allEmployees.forEach(emp => {

//             if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

//             const joinDate = new Date(emp.JoiningDate);

//             let sickMonths = 12;
//             if (joinDate > currentFYStart) {
//                 sickMonths =
//                     3 - joinDate.getMonth() +
//                     12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
//             }

//             balances[emp.EmailId] = {
//                 email: emp.EmailId,
//                 name: emp.full_name,
//                 dept: emp.Department,
//                 sick: 0,
//                 sickQuota: sickMonths,
//                 earned: 0,
//                 maxEarned: Number(emp.Earnedcount) || 0
//             };
//         });

//         // ✅ STEP 2: APPLY LEAVES
//         leaves.forEach(l => {

//             const empKey = l.EmailId;
//             if (!balances[empKey]) return;

//             if (l.Status === '1') {

//                 const days = parseFloat(l.total) || 0;
//                 const type = l.leavetype?.toLowerCase() || "";
//                 const medStatus = String(l.medical_doc_status);
//                 const leaveDate = new Date(l.fromdate);

//                 // Sick leave (FY)
//                 if (
//                     leaveDate >= currentFYStart &&
//                     leaveDate <= currentFYEnd &&
//                     type.includes('sick') &&
//                     medStatus !== '2'
//                 ) {
//                     balances[empKey].sick += days;
//                 }

//                 // Earned leave
//                 if (
//                     (type.includes('earned') && medStatus !== '1') ||
//                     (type.includes('sick') && medStatus === '2')
//                 ) {
//                     balances[empKey].earned += days;
//                 }
//             }
//         });

//         return Object.values(balances).filter(emp =>
//             !summarySearch ||
//             emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
//         );

//     }, [leaves, allEmployees, summarySearch, summaryDepartment]);

//     const chartData = useMemo(() => {
//         const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

//         return teamsToDisplay.map(team => {
//             const teamFilteredLeaves = leaves.filter(l => {
//                 const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

//                 return l.Department === team && matchesMonth && matchesYear;
//             });

//             return {
//                 name: team,

//                 // ✅ SUM of leave units instead of count
//                 Approved: teamFilteredLeaves
//                     .filter(l => l.Status === '1')
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

//                 Pending: teamFilteredLeaves
//                     .filter(l => (l.Status === '0' || l.Status === null))
//                     .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
//             };
//         });
//     }, [leaves, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === '1') return 'Approved';
//         if (status === '2') return 'Rejected';
//         return 'Pending';
//     };

//     const filteredTableData = leaves.filter(l => {
//         const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//         const matchesDept = filters.department === 'All' || l.Department === filters.department;
//         const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//         const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//         const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
//             (l.empid && l.empid.toString().includes(searchTerm));
//         return matchesDept && matchesMonth && matchesYear && matchesSearch;
//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body detail-grid" style={{
//                             padding: '20px',
//                             overflowY: 'auto',
//                             flex: 1,
//                             scrollbarWidth: 'thin',
//                             scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
//                         }}>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>LEAVE TYPE:</strong> {
//                                     (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
//                                         ? 'Sick Leave (Medical Approved)'
//                                         : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
//                                             ? 'Earned Leave (Converted)'
//                                             : selectedLeave.leavetype
//                                 }
//                             </p>
//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
//                             </p>

//                             <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
//                                 <strong>REASON:</strong>
//                                 <div style={{
//                                     marginTop: '8px',
//                                     color: '#ccc',
//                                     lineHeight: '1.5',

//                                     wordBreak: 'break-word',
//                                     whiteSpace: 'pre-wrap',
//                                     overflowWrap: 'break-word'
//                                 }}>
//                                     {selectedLeave.description || 'N/A'}
//                                 </div>
//                             </div>

//                             {(selectedLeave.proof || selectedLeave.medical_doc) && (
//                                 <div className="medical-review-panel" style={{
//                                     marginTop: '20px',
//                                     padding: '15px',
//                                     border: '1px solid #00ff9d',
//                                     borderRadius: '8px',
//                                     background: 'rgba(0, 255, 157, 0.05)',
//                                     marginBottom: '20px'
//                                 }}>
//                                     <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
//                                         DOCUMENTATION_REVIEW
//                                     </h4>

//                                     <img
//                                         src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
//                                         alt="Proof"
//                                         style={{
//                                             width: '100%',
//                                             maxHeight: '300px',
//                                             objectFit: 'contain',
//                                             marginBottom: '15px',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer',
//                                             border: '1px solid #333'
//                                         }}
//                                         onClick={() =>
//                                             window.open(
//                                                 `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
//                                                 '_blank'
//                                             )
//                                         }
//                                     />

//                                     {/* Only show status — no approve/reject buttons */}
//                                     <div style={{
//                                         textAlign: 'center',
//                                         padding: '10px',
//                                         border: '1px solid #333',
//                                         borderRadius: '4px',
//                                         background: 'rgba(0,0,0,0.3)'
//                                     }}>
//                                         <span style={{
//                                             fontSize: '11px',
//                                             fontWeight: '800',
//                                             color:
//                                                 String(selectedLeave.medical_doc_status) === '1'
//                                                     ? '#00ff9d'
//                                                     : String(selectedLeave.medical_doc_status) === '2'
//                                                         ? '#ff4d4d'
//                                                         : '#ccc'
//                                         }}>
//                                             {String(selectedLeave.medical_doc_status) === '1'
//                                                 ? 'VERIFIED AS SICK LEAVE'
//                                                 : String(selectedLeave.medical_doc_status) === '2'
//                                                     ? 'REJECTED (REMAINS EARNED)'
//                                                     : 'PENDING REVIEW'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}



//                         </div>


//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
//                                 <div className="modal-footer-actions">
//                                     <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
//                                     <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                             <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
//                             <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
//                                 {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = leaves.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
//                         style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
//                     >

//                         {pendingWFH > 0 && (
//                             <span
//                                 style={{
//                                     position: "absolute",
//                                     top: "8px",
//                                     right: "10px",
//                                     background: "#ff4d4d",
//                                     color: "#fff",
//                                     fontSize: "12px",
//                                     fontWeight: "700",
//                                     padding: "3px 7px",
//                                     borderRadius: "12px",
//                                     lineHeight: "1",
//                                     marginTop: "27px",
//                                 }}
//                             >
//                                 {pendingWFH}
//                             </span>
//                         )}

//                         <h4 className="cyan-text">WFH_REQUESTS</h4>

//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>
//                                 {/* VIEW_WFH_REQUESTS */}
//                             </span>
//                         </div>

//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
//                         <h4 className="cyan-text">
//                             {"MEDICAL_REPORTS"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">

//                         </div>
//                     </div>

//                     <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/leave-report')}
//                         style={{
//                             cursor: 'pointer',
//                             borderLeft: '4px solid #8b5cf6'
//                         }}
//                     >
//                         <h4 className="cyan-text">
//                             {"GENERATE_REPORT"
//                                 .toLowerCase()
//                                 .split("_")
//                                 .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//                                 .map((word, i, arr) => (
//                                     <span key={i}>
//                                         {word}
//                                         {i < arr.length - 1 && " -"}
//                                         <br />
//                                     </span>
//                                 ))}
//                         </h4>

//                         <div className="card-stats">
//                         </div>
//                     </div>
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>




//                 <table className="cyber-table" style={{ width: '100%', minWidth: '1200px', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>

//                         <tr>

//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 EMPLOYEE
//                             </th>
//                             <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
//                                 DEPT
//                             </th>
//                             <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
//                                 TYPE
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 FROM
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
//                                 TO
//                             </th>

//                             <th style={{ width: '70px', textAlign: 'center', padding: '12px' }}>
//                                 UNIT
//                             </th>
//                             <th style={{ width: '110px', textAlign: 'center', padding: '12px' }}>
//                                 STATUS
//                             </th>
//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 REVIEW
//                             </th>

//                             <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
//                                 LEAVE CONVERT
//                             </th>

//                             <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
//                                 ACTION
//                             </th>
//                         </tr>

//                     </thead>
//                     <tbody>
//                         {currentEntries.map((l, i) => {
//                             const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
//                             const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

//                             return (
//                                 <tr key={i} className="row-hover">

//                                     <td
//                                         className="emp-name-cell"
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             whiteSpace: 'nowrap'
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '4px',
//                                                 overflow: 'hidden',
//                                                 textOverflow: 'ellipsis'
//                                             }}
//                                         >
//                                             <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                                                 {l.FirstName} {l.LastName}
//                                             </span>

//                                             {isInProbation(l.JoiningDate) && (
//                                                 <span
//                                                     className="probation-badge"
//                                                     style={{
//                                                         width: 'fit-content',
//                                                         padding: '2px 8px',
//                                                         fontSize: '11px'
//                                                     }}
//                                                 >
//                                                     PROBATION
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             whiteSpace: 'nowrap'
//                                         }}
//                                     >
//                                         {l.Department}
//                                     </td>






//                                     <td
//                                         style={{
//                                             position: 'relative',
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <div style={{
//                                                 color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 {/* The primary name toggle */}
//                                                 {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
//                                                     String(l.medical_doc_status) === '2' ? 'Earned Leave' :
//                                                         l.leavetype}

//                                                 {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
//                                                 {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
//                                                     <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
//                                                         (MEDICAL APPROVED)
//                                                     </small>
//                                                 )}
//                                             </div>


//                                         </div>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.fromdate}
//                                     </td>
//                                     <td
//                                         style={{
//                                             padding: '14px 12px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {l.todate}
//                                     </td>

//                                     <td
//                                         style={{
//                                             fontWeight: 'bold',
//                                             color: '#00fff2',
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         {parseFloat(l.total)}
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                             {getStatusLabel(l.Status)}
//                                         </span>
//                                     </td>



//                                     <td
//                                         style={{
//                                             padding: '8px',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
//                                             <button
//                                                 className="info-btn-circle"
//                                                 onClick={() => {
//                                                     setSelectedLeave(l);
//                                                     setShowDetailModal(true);
//                                                 }}
//                                             >
//                                                 <span className="info-icon">i</span>
//                                             </button>
//                                         </div>
//                                     </td>

//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle'
//                                         }}
//                                     >
//                                         <button
//                                             className="convert-type-btn"
//                                             title="Toggle Leave Type"
//                                             onClick={() => {
//                                                 const currentType = String(l.medical_doc_status) === '1'
//                                                     ? 'Sick Leave'
//                                                     : String(l.medical_doc_status) === '2'
//                                                         ? 'Earned Leave'
//                                                         : (l.leavetype || '');

//                                                 const isCurrentlySick = currentType.toLowerCase().includes('sick');

//                                                 const nextType = isCurrentlySick
//                                                     ? "Earned Leave"
//                                                     : "Sick Leave";

//                                                 const nextStatusCode = isCurrentlySick
//                                                     ? 2
//                                                     : 1;

//                                                 if (
//                                                     window.confirm(
//                                                         `Do you want to convert this leave to ${nextType}?`
//                                                     )
//                                                 ) {
//                                                     handleMedicalAction(
//                                                         l.leave_id || l.id,
//                                                         nextStatusCode
//                                                     );
//                                                 }
//                                             }}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '20px',
//                                                 marginTop: '-10px'
//                                             }}
//                                         >
//                                             🔄
//                                         </button>
//                                     </td>



//                                     <td
//                                         style={{
//                                             textAlign: 'center',
//                                             verticalAlign: 'middle',
//                                             //  marginTop: '-20px'
//                                         }}
//                                     >
//                                         {(l.Status !== '0' && l.Status !== null) && (
//                                             <button
//                                                 className="btn-delete-simple"
//                                                 onClick={() => handleDeleteLeave(l.id)}
//                                                 style={{
//                                                     background: 'none',
//                                                     border: '6px',
//                                                     padding: '0',
//                                                     cursor: 'pointer',
//                                                     fontSize: '22px',
//                                                     opacity: '0.8',
//                                                     transition: 'opacity 0.2s, transform 0.2s',
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     marginTop: '-14px'
//                                                 }}
//                                                 onMouseOver={(e) => {
//                                                     e.currentTarget.style.opacity = '1';
//                                                     e.currentTarget.style.transform = 'scale(1.1)';
//                                                 }}
//                                                 onMouseOut={(e) => {
//                                                     e.currentTarget.style.opacity = '0.8';
//                                                     e.currentTarget.style.transform = 'scale(1)';
//                                                 }}
//                                             >
//                                                 🗑️


//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>



//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_LEAVE_QUOTA
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

//                             {/* <input
//                                 type="text"
//                                 placeholder="Search Employee..."
//                                 className="filter-select"
//                                 value={summarySearch}
//                                 onChange={(e) => setSummarySearch(e.target.value)}
//                                 style={{ width: '220px', fontSize: '12px' }}
//                             /> */}
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
//                     <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {leaveBalances.map((emp, idx) => (
//                         <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
//                             <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
//                             <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
//                                 {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
//                             </div>

//                             <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
//                                 {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
//                             </div>
//                         </div>
//                     ))}
//                     {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeaveManagement;













































import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { createPortal } from 'react-dom';

import '../styles/LeaveManagement.css';

const LeaveManagement = () => {
    const navigate = useNavigate();
    const [leaves, setLeaves] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]); // ✅ ADD THIS LINE
    const [pendingWFH, setPendingWFH] = useState(0);
    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [summarySearch, setSummarySearch] = useState('');
    const [showDetailModal, setShowDetailModal] = useState(false);

    const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
    const [remarkText, setRemarkText] = useState("");
    const [dashboardDepartments, setDashboardDepartments] = useState([]);
    useEffect(() => {

        const storedUser =
            localStorage.getItem("userData");

        const user =
            JSON.parse(storedUser || "{}");

        const email =
            user?.EmailId || "";

        const isGenesis =
            email.toLowerCase().includes("genesistech.co.in") ||
            email.toLowerCase().includes("gtecorpgroup.com") ||
            email.toLowerCase().includes("gtcorpgroup.com");

        if (isGenesis) return;

        fetch(
            "/gt-api/get_departments.php",
            {
                credentials: "include"
            }
        )
            .then(res => res.json())
            .then(data => {

                if (data.success) {

                    setDashboardDepartments(
                        data.departments || []
                    );

                }

            })
            .catch(console.error);

    }, []);

    const [summaryDepartment, setSummaryDepartment] = useState('All');
    const entriesPerPage = 10;

    const teams = useMemo(() => {

        const storedUser =
            localStorage.getItem("userData");

        const user =
            JSON.parse(storedUser || "{}");

        const email =
            user?.EmailId || "";

        const isGenesis =
            email.toLowerCase().includes("genesistech.co.in") ||
            email.toLowerCase().includes("gtecorpgroup.com") ||
            email.toLowerCase().includes("gtcorpgroup.com");

        return isGenesis

            ? [
                "FI Design",
                "FSPLO",
                "LTDM PC",
                "DDI",
                "DMS",
                "FI-IE",
                "LTO",
                "GTE-Technology Operations"
            ]

            : dashboardDepartments.map(
                dept => dept.DepartmentName
            );

    }, [dashboardDepartments]);

    const now = new Date();
    const currentMonth = (now.getMonth() + 1).toString();
    const currentYear = now.getFullYear().toString();

    const [filters, setFilters] = useState({
        department: 'All',
        month: currentMonth,
        year: currentYear,
    });



    const pendingCount = useMemo(() => {
        return leaves.filter(l => l.Status === '0' || l.Status === null).length;
    }, [leaves]);

    // Wrapped in useCallback to allow use in handleMedicalAction
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            // const storedUser = localStorage.getItem('user');
            const storedUser = localStorage.getItem('userData');
            const authUser = JSON.parse(storedUser) || {};
            const viewerId = authUser.EmpId || authUser.empid || "";
            const role = authUser.Role || authUser.role || "";

            const res = await fetch(`/gt-api/get_all_leaves.php?viewerId=${viewerId}&role=${role}`, {
                credentials: "include"
            });

            const data = await res.json();



            if (data.success) {
                setLeaves(data.leaves);
                setAllEmployees(data.employees);
            } else {
                console.error("Backend Error:", data.message);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDeleteLeave = async (id) => {
        if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
        setProcessing(true);
        try {
            const res = await fetch(`/gt-api/delete_leave_admin.php?id=${id}`, {
                method: 'GET',
                credentials: "include"
            });
            const result = await res.json();
            if (result.success) {
                await fetchData();
            } else {
                alert("Delete failed: " + result.message);
            }
        } catch (e) {
            alert("Connection error during deletion");
        } finally {
            setProcessing(false);
        }
    };


    const handleMedicalAction = async (leaveId, actionType) => {
        // actionType: 1 for Sick, 2 for Earned
        setProcessing(true);
        try {

            // Determine new leave type based on action
            const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

            const response = await fetch("/gt-api/verify_medical.php", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    leave_id: leaveId,
                    status: actionType,
                    leavetype: newLeaveType   // 👈 added this
                }),
            });

            const result = await response.json();

            if (result.success) {
                setSelectedLeave(prev => ({
                    ...prev,
                    medical_doc_status: actionType,
                    leavetype: newLeaveType   // 👈 update UI state also
                }));

                fetchData(); // Refresh list in background
            }

        } catch (error) {
            console.error("Verification failed", error);
        } finally {
            setProcessing(false);
        }
    };

    const openRemarkModal = (id, statusValue) => {
        const actionType = statusValue === 1 ? "APPROVE" : "REJECT";
        const targetId = id || selectedLeave?.leave_id || selectedLeave?.id;
        setRemarkModal({ show: true, id: targetId, status: statusValue, actionType });
        setRemarkText("");
    };

    const handleFinalSubmit = async () => {
        const targetId = remarkModal.id || selectedLeave?.leave_id || selectedLeave?.id;
        if (!targetId) {
            alert("Error: No leave record selected.");
            return;
        }
        const finalRemark = remarkText.trim() || (remarkModal.status === 1 ? "Approved by Management" : "Rejected by Management");
        const statusVal = remarkModal.status;

        // 1. Instantly update UI locally (Optimistic update)
        setLeaves(prevLeaves => prevLeaves.map(l => {
            const lId = l.id || l.leave_id || l.lid;
            if (String(lId) === String(targetId)) {
                return { ...l, Status: String(statusVal), status: String(statusVal), AdminRemark: finalRemark };
            }
            return l;
        }));

        // 2. Instantly close both modals & reset remark state
        setRemarkModal({ show: false, id: null, status: null, actionType: "" });
        setShowDetailModal(false);

        // 3. Send update request to server in background without blocking UI
        try {
            let authUser = {};
            try {
                authUser = JSON.parse(localStorage.getItem('user')) ||
                    JSON.parse(localStorage.getItem('userData')) ||
                    JSON.parse(localStorage.getItem('employee')) ||
                    JSON.parse(localStorage.getItem('auth')) || {};
            } catch (e) { }

            const approverId = authUser.EmpId || authUser.empId || authUser.empid || authUser.emp_id || authUser.EmpCode || authUser.id || authUser.EmailId || authUser.email || "";
            const approverName = authUser.FirstName
                ? `${authUser.FirstName} ${authUser.LastName || ''}`.trim()
                : (authUser.name || authUser.full_name || authUser.EmailId || authUser.email || "");

            fetch("/gt-api/update_leave_status.php", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: targetId,
                    status: statusVal,
                    remark: finalRemark,
                    approved_by_id: approverId,
                    approved_by_name: approverName
                }),
            }).then(res => res.json()).then(result => {
                if (!result.success) {
                    alert("Update failed: " + (result.message || "Server error"));
                    fetchData();
                } else {
                    fetchData();
                }
            }).catch(err => {
                console.error("Leave update background error:", err);
                fetchData();
            });
        } catch (e) {
            console.error("Error sending leave update:", e);
        }
    };

    const isInProbation = (joiningDate, probationStatus) => {
        if (probationStatus) {
            return probationStatus !== 'Permanent';
        }

        if (!joiningDate) return false;

        const join = new Date(joiningDate);
        const probationEnd = new Date(join);
        probationEnd.setMonth(probationEnd.getMonth() + 6);

        const today = new Date();

        return today <= probationEnd;
    };



    useEffect(() => {

        const fetchWFHCount = async () => {
            try {

                const res = await fetch("/gt-api/get_all_wfh_requests.php", {
                    credentials: "include"
                });

                const data = await res.json();

                if (data.success) {

                    const pending = data.requests.filter(r => r.status === "Pending").length;

                    setPendingWFH(pending);

                }

            } catch (err) {

                console.error("WFH count fetch error", err);

            }
        };

        fetchWFHCount();

        const interval = setInterval(fetchWFHCount, 5000);

        return () => clearInterval(interval);

    }, []);



    const leaveBalances = useMemo(() => {
        const balances = {};
        const now = new Date();

        const currentFYStart = now.getMonth() >= 3
            ? new Date(now.getFullYear(), 3, 1)
            : new Date(now.getFullYear() - 1, 3, 1);

        const currentFYEnd = new Date(currentFYStart.getFullYear() + 1, 2, 31);

        // ✅ STEP 1: ADD ALL EMPLOYEES FIRST
        allEmployees.forEach(emp => {

            if (summaryDepartment !== 'All' && emp.Department !== summaryDepartment) return;

            const joinDate = new Date(emp.JoiningDate);

            let sickMonths = 12;
            if (joinDate > currentFYStart) {
                sickMonths =
                    3 - joinDate.getMonth() +
                    12 * (currentFYEnd.getFullYear() - joinDate.getFullYear());
            }

            balances[emp.EmailId] = {
                email: emp.EmailId,
                name: emp.full_name,
                dept: emp.Department,
                sick: 0,
                sickQuota: sickMonths,
                earned: 0,
                maxEarned: Number(emp.Earnedcount) || 0
            };
        });

        // ✅ STEP 2: APPLY LEAVES
        leaves.forEach(l => {

            const empKey = l.EmailId;
            if (!balances[empKey]) return;

            if (l.Status === '1') {

                const days = parseFloat(l.total) || 0;
                const type = l.leavetype?.toLowerCase() || "";
                const medStatus = String(l.medical_doc_status);
                const leaveDate = new Date(l.fromdate);

                // Sick leave (FY)
                if (
                    leaveDate >= currentFYStart &&
                    leaveDate <= currentFYEnd &&
                    type.includes('sick') &&
                    medStatus !== '2'
                ) {
                    balances[empKey].sick += days;
                }

                // Earned leave
                if (
                    (type.includes('earned') && medStatus !== '1') ||
                    (type.includes('sick') && medStatus === '2')
                ) {
                    balances[empKey].earned += days;
                }
            }
        });

        return Object.values(balances).filter(emp =>
            !summarySearch ||
            emp.name?.toLowerCase().includes(summarySearch.toLowerCase())
        );

    }, [leaves, allEmployees, summarySearch, summaryDepartment]);

    const chartData = useMemo(() => {
        const teamsToDisplay = filters.department === 'All' ? teams : [filters.department];

        return teamsToDisplay.map(team => {
            const teamFilteredLeaves = leaves.filter(l => {
                const dateParts = l.fromdate ? l.fromdate.split('-') : [];
                const lYear = dateParts[0];
                const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";

                const matchesMonth = filters.month === 'All' || lMonth === filters.month;
                const matchesYear = filters.year === 'All' || lYear === filters.year.toString();

                return l.Department === team && matchesMonth && matchesYear;
            });

            return {
                name: team,

                // ✅ SUM of leave units instead of count
                Approved: teamFilteredLeaves
                    .filter(l => l.Status === '1')
                    .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0),

                Pending: teamFilteredLeaves
                    .filter(l => (l.Status === '0' || l.Status === null))
                    .reduce((sum, l) => sum + (parseFloat(l.total) || 0), 0)
            };
        });
    }, [leaves, filters.month, filters.year, filters.department, teams]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
        setCurrentPage(1);
    };

    const handleTeamClick = (teamName) => {
        setFilters(prev => ({ ...prev, department: teamName }));
        setCurrentPage(1);
    };

    const getStatusLabel = (status) => {
        if (status === '1') return 'Approved';
        if (status === '2') return 'Rejected';
        return 'Pending';
    };

    const filteredTableData = leaves.filter(l => {
        const dateParts = l.fromdate ? l.fromdate.split('-') : [];
        const lYear = dateParts[0] || "";
        const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
        const matchesDept = filters.department === 'All' || l.Department === filters.department;
        const matchesMonth = filters.month === 'All' || lMonth === filters.month;
        const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
        const matchesSearch = (l.EmailId && l.EmailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (l.empid && l.empid.toString().includes(searchTerm));
        return matchesDept && matchesMonth && matchesYear && matchesSearch;
    });

    const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
    const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

    if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

    return (
        <div className="leave-mgmt-container animate-fade">


            {processing && createPortal(
                <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
                    <div className="processing-loader">
                        <div className="spinner-ring"></div>
                        <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
                    </div>
                </div>,
                document.body
            )}






            {showDetailModal && selectedLeave && createPortal(
                <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
                    <div className="detail-modal glass-morph animate-slide-up"
                        onClick={e => e.stopPropagation()}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '90vh',
                            width: '80%',
                            maxWidth: '600px'
                        }}>


                        <div className="modal-header" style={{ flexShrink: 0 }}>
                            <h3 className="cyan-text">APPLICATION_DETAILS</h3>
                            <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
                        </div>

                        <div className="modal-body detail-grid" style={{
                            padding: '20px',
                            overflowY: 'auto',
                            flex: 1,
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#00fff2 rgba(0,0,0,0.2)'
                        }}>
                            <p style={{ marginBottom: '15px' }}>
                                <strong>EMPLOYEE:</strong> {selectedLeave.FirstName} {selectedLeave.LastName}
                            </p>
                            <p style={{ marginBottom: '15px' }}>
                                <strong>LEAVE TYPE:</strong> {
                                    (selectedLeave.leavetype === 'Earned Leave' && String(selectedLeave.medical_doc_status) === '1')
                                        ? 'Sick Leave (Medical Approved)'
                                        : (selectedLeave.leavetype === 'Sick Leave' && String(selectedLeave.medical_doc_status) === '2')
                                            ? 'Earned Leave (Converted)'
                                            : selectedLeave.leavetype
                                }
                            </p>
                            <p style={{ marginBottom: '15px' }}>
                                <strong>PERIOD:</strong> {selectedLeave.fromdate} TO {selectedLeave.todate}
                            </p>

                            <div className="reason-box" style={{ marginBottom: '20px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '4px' }}>
                                <strong>REASON:</strong>
                                <div style={{
                                    marginTop: '8px',
                                    color: '#ccc',
                                    lineHeight: '1.5',

                                    wordBreak: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word'
                                }}>
                                    {selectedLeave.description || 'N/A'}
                                </div>
                            </div>

                            {(selectedLeave.proof || selectedLeave.medical_doc) && (
                                <div className="medical-review-panel" style={{
                                    marginTop: '20px',
                                    padding: '15px',
                                    border: '1px solid #00ff9d',
                                    borderRadius: '8px',
                                    background: 'rgba(0, 255, 157, 0.05)',
                                    marginBottom: '20px'
                                }}>
                                    <h4 style={{ color: '#00ff9d', marginBottom: '10px', fontSize: '12px' }}>
                                        DOCUMENTATION_REVIEW
                                    </h4>

                                    <img
                                        src={`/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`}
                                        alt="Proof"
                                        style={{
                                            width: '100%',
                                            maxHeight: '300px',
                                            objectFit: 'contain',
                                            marginBottom: '15px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            border: '1px solid #333'
                                        }}
                                        onClick={() =>
                                            window.open(
                                                `/gt-api/uploads/${selectedLeave.medical_doc || selectedLeave.proof}`,
                                                '_blank'
                                            )
                                        }
                                    />

                                    {/* Only show status — no approve/reject buttons */}
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '10px',
                                        border: '1px solid #333',
                                        borderRadius: '4px',
                                        background: 'rgba(0,0,0,0.3)'
                                    }}>
                                        <span style={{
                                            fontSize: '11px',
                                            fontWeight: '800',
                                            color:
                                                String(selectedLeave.medical_doc_status) === '1'
                                                    ? '#00ff9d'
                                                    : String(selectedLeave.medical_doc_status) === '2'
                                                        ? '#ff4d4d'
                                                        : '#ccc'
                                        }}>
                                            {String(selectedLeave.medical_doc_status) === '1'
                                                ? 'VERIFIED AS SICK LEAVE'
                                                : String(selectedLeave.medical_doc_status) === '2'
                                                    ? 'REJECTED (REMAINS EARNED)'
                                                    : 'PENDING REVIEW'}
                                        </span>
                                    </div>
                                </div>
                            )}



                        </div>


                        <div className="modal-footer" style={{ flexShrink: 0 }}>
                            {(selectedLeave.Status === '0' || selectedLeave.Status === null) && (
                                <div className="modal-footer-actions">
                                    <button className="btn-approve" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 1)}>APPROVE</button>
                                    <button className="btn-reject" onClick={() => openRemarkModal(selectedLeave.leave_id || selectedLeave.id, 2)}>REJECT</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {remarkModal.show && createPortal(
                <div className="modal-overlay" style={{ zIndex: 2000 }}>
                    <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

                        <div className="modal-header">
                            <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
                                {remarkModal.actionType}_CONFIRMATION
                            </h3>
                        </div>
                        <div className="modal-body">
                            <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
                            <textarea
                                className="filter-select"
                                style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
                                placeholder="Write remark here..."
                                value={remarkText}
                                onChange={(e) => setRemarkText(e.target.value)}
                            />
                        </div>
                        <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                            <button className="page-btn" style={{ flex: 1 }} onClick={() => setRemarkModal({ show: false })}>CANCEL</button>
                            <button className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"} style={{ flex: 1, padding: '10px' }} onClick={handleFinalSubmit} disabled={processing}>
                                {processing ? "..." : `CONFIRM ${remarkModal.actionType}`}
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}

            <div className="leave-dashboard-top">
                <div className="team-cards-grid">
                    {teams.map((team, idx) => {
                        const filteredForCard = leaves.filter(l => {
                            const dateParts = l.fromdate ? l.fromdate.split('-') : [];
                            const lYear = dateParts[0];
                            const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
                            const matchesMonth = filters.month === 'All' || lMonth === filters.month;
                            const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
                            return l.Department === team && matchesMonth && matchesYear;
                        });

                        return (
                            <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
                                <h4>{team}</h4>
                                <div className="card-stats">
                                    <span className="stat-item approved">{filteredForCard.filter(l => l.Status === '1').length}A</span>
                                    <span className="stat-item pending">{filteredForCard.filter(l => (l.Status === '0' || l.Status === null)).length}P</span>
                                </div>
                            </div>

                        );
                    })}


                    <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
                        onClick={() => {
                            setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
                            setCurrentPage(1);
                        }}>
                        <h4 className="cyan-text">GLOBAL_VIEW</h4>
                        <div className="card-stats"><span>{leaves.length} TOTAL ALL TIME</span></div>
                    </div>

                    <div
                        className="team-mini-card glass-morph medical-card"
                        onClick={() => navigate('/dashboard/Management/manage-wfh-requests')}
                        style={{ cursor: 'pointer', borderLeft: '4px solid #3b82f6', position: "relative" }}
                    >

                        {pendingWFH > 0 && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "8px",
                                    right: "10px",
                                    background: "#ff4d4d",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    padding: "3px 7px",
                                    borderRadius: "12px",
                                    lineHeight: "1",
                                    marginTop: "27px",
                                }}
                            >
                                {pendingWFH}
                            </span>
                        )}

                        <h4 className="cyan-text">WFH_REQUESTS</h4>

                        <div className="card-stats">
                            <span style={{ fontSize: '10px', color: '#888' }}>
                                {/* VIEW_WFH_REQUESTS */}
                            </span>
                        </div>

                    </div>

                    <div
                        className="team-mini-card glass-morph medical-card"
                        onClick={() => navigate('/medical-reports')} // Replace with your actual route path
                        style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
                    >
                        {/* <h4 className="cyan-text">MEDICAL_REPORTS</h4> */}
                        <h4 className="cyan-text">
                            {"MEDICAL_REPORTS"
                                .toLowerCase()
                                .split("_")
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .map((word, i, arr) => (
                                    <span key={i}>
                                        {word}
                                        {i < arr.length - 1 && " -"}
                                        <br />
                                    </span>
                                ))}
                        </h4>

                        <div className="card-stats">

                        </div>
                    </div>

                    <div
                        className="team-mini-card glass-morph medical-card"
                        onClick={() => navigate('/leave-report')}
                        style={{
                            cursor: 'pointer',
                            borderLeft: '4px solid #8b5cf6'
                        }}
                    >
                        <h4 className="cyan-text">
                            {"GENERATE_REPORT"
                                .toLowerCase()
                                .split("_")
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .map((word, i, arr) => (
                                    <span key={i}>
                                        {word}
                                        {i < arr.length - 1 && " -"}
                                        <br />
                                    </span>
                                ))}
                        </h4>

                        <div className="card-stats">
                        </div>
                    </div>
                </div>

                <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
                        {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
                    </h5>
                    <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
                        <ResponsiveContainer width="100%" height={220}>
                            <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
                                <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
                                <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
                                <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
                                <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
                                <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>


            </div>

            <div className="filter-toolbar glass-morph">

                <div className="leavefilter">
                    <label>MONTH</label>
                    <select name="month" value={filters.month} onChange={handleFilterChange}>
                        <option value="All">ALL MONTHS</option>
                        {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
                            <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
                        ))}
                    </select>
                </div>
                <div className="leavefilter">
                    <label>YEAR</label>
                    <select name="year" value={filters.year} onChange={handleFilterChange}>
                        <option value="All">ALL YEARS</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                    </select>
                </div>

                <div className="leavefilter">
                    <label>DEPARTMENT</label>
                    <select name="department" value={filters.department} onChange={handleFilterChange}>
                        <option value="All">ALL DEPARTMENTS</option>
                        {teams.map(team => (
                            <option key={team} value={team}>{team.toUpperCase()}</option>
                        ))}
                    </select>
                </div>

                <div className="leavefilter search-group">
                    <label>EMPLOYEE_SEARCH</label>
                    <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="leavefilter reset-group">
                    <label>SYSTEM_CONTROL</label>
                    <button
                        className="reset-action-btn"
                        onClick={() => {
                            setFilters({
                                department: 'All',
                                month: currentMonth, // Returns to original current month
                                year: currentYear,   // Returns to original current year
                            });
                            setSearchTerm('');
                            setCurrentPage(1);
                        }}
                    >
                        <span className="reset-icon"></span>
                        RESET_FILTER
                    </button>
                </div>
            </div>

            <div className="module-glass-card table-wrapper">
                <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
                    <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
                    {pendingCount > 0 && (
                        <div className="notif-badge-main">{pendingCount}</div>
                    )}
                </div>




                <table className="cyber-table" style={{ width: '100%', minWidth: '1200px', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                    <thead>

                        <tr>

                            <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
                                EMPLOYEE
                            </th>
                            <th style={{ width: '200px', textAlign: 'left', padding: '12px' }}>
                                DEPT
                            </th>
                            <th style={{ width: '140px', textAlign: 'left', padding: '12px' }}>
                                TYPE
                            </th>
                            <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
                                FROM
                            </th>
                            <th style={{ width: '110px', textAlign: 'left', padding: '12px' }}>
                                TO
                            </th>

                            <th style={{ width: '70px', textAlign: 'center', padding: '12px' }}>
                                UNIT
                            </th>
                            <th style={{ width: '110px', textAlign: 'center', padding: '12px' }}>
                                STATUS
                            </th>
                            <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
                                REVIEW
                            </th>

                            <th style={{ width: '120px', textAlign: 'center', padding: '12px' }}>
                                LEAVE CONVERT
                            </th>

                            <th style={{ width: '80px', textAlign: 'center', padding: '12px' }}>
                                ACTION
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {currentEntries.map((l, i) => {
                            const isMedicalApproved = l.leavetype === 'Earned Leave' && String(l.medical_doc_status) === '1';
                            const isConvertedToEarned = l.leavetype === 'Sick Leave' && String(l.medical_doc_status) === '2';

                            return (
                                <tr key={i} className="row-hover">

                                    <td
                                        className="emp-name-cell"
                                        style={{
                                            padding: '14px 12px',
                                            verticalAlign: 'middle',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '4px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {l.FirstName} {l.LastName}
                                            </span>

                                            {isInProbation(l.JoiningDate, l.probation_status) && (
                                                <span
                                                    className="probation-badge"
                                                    style={{
                                                        width: 'fit-content',
                                                        padding: '2px 8px',
                                                        fontSize: '11px'
                                                    }}
                                                >
                                                    PROBATION
                                                </span>
                                            )}
                                        </div>
                                    </td>

                                    <td
                                        style={{
                                            padding: '14px 12px',
                                            verticalAlign: 'middle',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {l.Department}
                                    </td>






                                    <td
                                        style={{
                                            position: 'relative',
                                            padding: '14px 12px',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <div style={{
                                                color: (String(l.medical_doc_status) === '1') ? '#ffffff' : 'inherit',
                                                fontWeight: '500'
                                            }}>
                                                {/* The primary name toggle */}
                                                {String(l.medical_doc_status) === '1' ? 'Sick Leave' :
                                                    String(l.medical_doc_status) === '2' ? 'Earned Leave' :
                                                        l.leavetype}

                                                {/* ONLY show (MEDICAL APPROVED) if there is a document AND status is 1 */}
                                                {(l.medical_doc || l.proof) && String(l.medical_doc_status) === '1' && (
                                                    <small style={{ display: 'block', fontSize: '9px', color: '#ffffff', fontWeight: '600' }}>
                                                        (MEDICAL APPROVED)
                                                    </small>
                                                )}
                                            </div>


                                        </div>
                                    </td>



                                    <td
                                        style={{
                                            padding: '14px 12px',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {l.fromdate}
                                    </td>
                                    <td
                                        style={{
                                            padding: '14px 12px',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {l.todate}
                                    </td>

                                    <td
                                        style={{
                                            fontWeight: 'bold',
                                            color: '#00fff2',
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {parseFloat(l.total)}
                                    </td>

                                    <td
                                        style={{
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <span className={`status-pill ${getStatusLabel(l.Status).toLowerCase()}`} style={{ fontSize: '11px' }}>
                                            {getStatusLabel(l.Status)}
                                        </span>
                                    </td>



                                    <td
                                        style={{
                                            padding: '8px',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '0px', marginTop: '-16px' }}>
                                            <button
                                                className="info-btn-circle"
                                                onClick={() => {
                                                    setSelectedLeave(l);
                                                    setShowDetailModal(true);
                                                }}
                                            >
                                                <span className="info-icon">i</span>
                                            </button>
                                        </div>
                                    </td>

                                    <td
                                        style={{
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <button
                                            className="convert-type-btn"
                                            title="Toggle Leave Type"
                                            onClick={() => {
                                                const currentType = String(l.medical_doc_status) === '1'
                                                    ? 'Sick Leave'
                                                    : String(l.medical_doc_status) === '2'
                                                        ? 'Earned Leave'
                                                        : (l.leavetype || '');

                                                const isCurrentlySick = currentType.toLowerCase().includes('sick');

                                                const nextType = isCurrentlySick
                                                    ? "Earned Leave"
                                                    : "Sick Leave";

                                                const nextStatusCode = isCurrentlySick
                                                    ? 2
                                                    : 1;

                                                if (
                                                    window.confirm(
                                                        `Do you want to convert this leave to ${nextType}?`
                                                    )
                                                ) {
                                                    handleMedicalAction(
                                                        l.leave_id || l.id,
                                                        nextStatusCode
                                                    );
                                                }
                                            }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '20px',
                                                marginTop: '-10px'
                                            }}
                                        >
                                            🔄
                                        </button>
                                    </td>



                                    <td
                                        style={{
                                            textAlign: 'center',
                                            verticalAlign: 'middle',
                                            //  marginTop: '-20px'
                                        }}
                                    >
                                        {(l.Status !== '0' && l.Status !== null) && (
                                            <button
                                                className="btn-delete-simple"
                                                onClick={() => handleDeleteLeave(l.id)}
                                                style={{
                                                    background: 'none',
                                                    border: '6px',
                                                    padding: '0',
                                                    cursor: 'pointer',
                                                    fontSize: '22px',
                                                    opacity: '0.8',
                                                    transition: 'opacity 0.2s, transform 0.2s',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginTop: '-14px'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.opacity = '1';
                                                    e.currentTarget.style.transform = 'scale(1.1)';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.opacity = '0.8';
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                            >
                                                🗑️


                                            </button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>



                <div className="pagination-footer">
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
                    <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
                    <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
                </div>
            </div>




            <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
                    {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '20px 20px 10px 20px',
                        gap: '15px'
                    }}>
                        <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
                            EMPLOYEE_LEAVE_QUOTA
                        </h3>

                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                            {/* ✅ New Department Filter for Summary Only */}
                            <select
                                className="filter-select"
                                value={summaryDepartment}
                                onChange={(e) => setSummaryDepartment(e.target.value)}
                                style={{ fontSize: '12px' }}
                            >
                                <option value="All">ALL DEPARTMENTS</option>
                                {teams.map(team => (
                                    <option key={team} value={team}>{team.toUpperCase()}</option>
                                ))}
                            </select>

                            {/* <input
                                type="text"
                                placeholder="Search Employee..."
                                className="filter-select"
                                value={summarySearch}
                                onChange={(e) => setSummarySearch(e.target.value)}
                                style={{ width: '220px', fontSize: '12px' }}
                            /> */}
                        </div>
                    </div>
                    <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
                </div>
                <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
                    <div className="header-label" style={{ flex: '3', minWidth: 0 }}>EMPLOYEE</div>
                    <div className="header-label" style={{ flex: '2', minWidth: 0 }}>DEPARTMENT</div>
                    <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_SICK LEAVE</div>
                    <div className="header-label" style={{ flex: '1.5', minWidth: 0, textAlign: 'center' }}>USED_EARNED LEAVE</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {leaveBalances.map((emp, idx) => (
                        <div key={idx} className="row-hover" style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>
                            <div className="emp-email-text" style={{ flex: '3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.name}</div>
                            <div className="dept-text" style={{ flex: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{emp.dept}</div>
                            <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.sick >= emp.sickQuota ? '#ff4d4d' : '#00ff9d', minWidth: 0 }}>
                                {emp.sick}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.sickQuota}</span>
                            </div>

                            <div style={{ flex: '1.5', textAlign: 'center', fontWeight: '800', fontSize: '15px', color: emp.earned >= (emp.maxEarned - 2) ? '#ff4d4d' : '#00d9ff', minWidth: 0 }}>
                                {emp.earned}<span className="denominator-text" style={{ fontSize: '11px', fontWeight: '400' }}>/{emp.maxEarned}</span>
                            </div>
                        </div>
                    ))}
                    {leaveBalances.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>DATA_NOT_FOUND_FOR_PERIOD</div>}
                </div>
            </div>
        </div>
    );
};

export default LeaveManagement;

